const he = {
    // ==================== COMMON ====================
    common: {
        appName: 'Email Lion',
        loading: 'טוען...',
        error: 'שגיאה',
        success: 'הצלחה',
        save: 'שמור',
        cancel: 'ביטול',
        close: 'סגור',
        delete: 'מחק',
        edit: 'עריכה',
        create: 'צור',
        update: 'עדכון',
        back: 'חזרה',
        next: 'הבא',
        previous: 'הקודם',
        search: 'חיפוש',
        refresh: 'רענון',
        send: 'שלח',
        confirm: 'אישור',
        yes: 'כן',
        no: 'לא',
        or: 'או',
        all: 'הכל',
        none: 'ללא',
        status: 'סטטוס',
        name: 'שם',
        actions: 'פעולות',
        date: 'תאריך',
        time: 'זמן',
        today: 'היום',
        print: 'הדפס',
        export: 'ייצוא',
        import: 'ייבוא',
        test: 'בדיקה',
        enabled: 'פעיל',
        disabled: 'מושבת',
        default: 'ברירת מחדל',
        optional: 'אופציונלי',
        required: 'חובה',
        noData: 'אין נתונים להצגה',
        errorLoadingData: 'שגיאה בטעינת נתונים',
        errorSaving: 'שגיאה בשמירה',
        errorDeleting: 'שגיאה במחיקה',
        voiceBlocked: 'הדפדפן חסם את המיקרופון. אשרו גישה בהגדרות האתר ונסו שוב.',
        voiceNeedReload: 'המיקרופון כבר מאושר בהגדרות, אבל הדף עדיין לא רואה את זה. רעננו את הדף ואז לחצו שוב על המיקרופון.',
        voiceNoDevice: 'לא נמצא מיקרופון מחובר. בדקו שהמכשיר מחובר ומורשה ב-Windows או ב-macOS.',
        voiceBusy: 'המיקרופון תפוס באפליקציה אחרת. סגרו Zoom, Teams או Meet ונסו שוב.',
        voiceSpeechFailed: 'זיהוי הדיבור נכשל. נסו שוב, או רעננו את הדף.',
        voiceNotSupported: 'הקלטה קולית אינה נתמכת בדפדפן זה. השתמשו ב-Chrome.',
        voiceInputTooltip: 'הקלד קולית',
        voiceStop: 'עצור הקלטה',
        voiceListening: 'מאזין... דבר עכשיו',
        upgradeRequired: 'לשימוש במודול זה יש לשדרג את החבילה או לפנות למנהל המערכת.',
        viewPlans: 'צפה בחבילות ושדרג',
        files: 'קבצים',
        from: 'מאת',
        subject: 'נושא',
        noSubject: '(ללא נושא)',
        email: 'אימייל',
        password: 'סיסמה',
        emailAccount: 'חשבון מייל',
        runNow: 'הרץ עכשיו',
        description: 'תיאור',
        errorLoadingAccounts: 'שגיאה בטעינת חשבונות',
        errorStatusChange: 'שגיאה בשינוי מצב',
        errorLogin: 'שגיאה בהתחברות',
        use: 'השתמש',
        recommended: 'מומלץ',
        free: 'חינם',
    },

    // ==================== LOGIN ====================
    login: {
        subtitle: 'מערכת דואר אלקטרוני ארגונית',
        loginTab: 'התחברות',
        registerTab: 'הרשמה חינם',
        emailLabel: 'אימייל',
        passwordLabel: 'סיסמה',
        twoFactorLabel: 'קוד אימות דו-שלבי (2FA)',
        twoFactorHelper: 'הזן את הקוד מאפליקציית האימות',
        verifyAndLogin: 'אמת והתחבר',
        loginButton: 'התחבר',
        forgotPassword: 'שכחתי סיסמה',
        fullName: 'שם מלא *',
        emailRequired: 'אימייל *',
        passwordRequired: 'סיסמה *',
        minChars: 'לפחות 6 תווים',
        confirmPassword: 'אימות סיסמה *',
        passwordsMismatch: 'הסיסמאות אינן תואמות',
        companyName: 'שם חברה (אופציונלי)',
        phone: 'טלפון *',
        phoneHelper: 'מספר נייד או קווי תקין (לפחות 9 ספרות)',
        registering: 'נרשם...',
        registerFree: 'הרשם בחינם',
        freePlan: 'חבילה חינמית · ללא כרטיס אשראי · 1 תיבת מייל',
        googleLogin: 'התחבר עם Google',
        googleRegister: 'הרשם עם Google',
        termsAgree: 'בהרשמה, אני מסכים/ה ל',
        termsOfService: 'תנאי השימוש',
        privacyPolicy: 'מדיניות הפרטיות',
        backToSite: 'חזור לאתר הראשי',
        resetPassword: 'איפוס סיסמה',
        stepEnterEmail: 'הזנת אימייל',
        stepVerifyCode: 'אימות קוד',
        stepNewPassword: 'סיסמה חדשה',
        resetEmailPrompt: 'הזן את כתובת האימייל שלך ונשלח לך קוד לאיפוס הסיסמה.',
        emailAddress: 'כתובת אימייל',
        codeSentTo: 'נשלח קוד אימות ל-',
        enterCode: '. הזן את הקוד:',
        verificationCode: 'קוד אימות (6 ספרות)',
        newPasswordPrompt: 'הזן את הסיסמה החדשה (לפחות 6 תווים):',
        newPassword: 'סיסמה חדשה',
        confirmPasswordLabel: 'אימות סיסמה',
        sendCode: 'שלח קוד',
        verifyCode: 'אמת קוד',
        resetPasswordBtn: 'אפס סיסמה',
        sessionExpired: 'פג תוקף החיבור. נא להתחבר שוב.',
        errorFullName: 'נא להזין שם מלא',
        errorValidEmail: 'נא להזין כתובת אימייל תקינה (לא כתובת זמנית)',
        errorPhone: 'נא להזין מספר טלפון תקין (לפחות 9 ספרות)',
        errorMinPassword: 'סיסמה חייבת להכיל לפחות 6 תווים',
        errorPasswordMatch: 'הסיסמאות אינן תואמות',
        registerSuccess: 'ההרשמה הושלמה! כעת תוכל להתחבר.',
        errorRegister: 'שגיאה בהרשמה',
        errorGoogleAuth: 'שגיאה באימות גוגל',
        errorGoogleFailed: 'אימות Google נכשל, נסה שוב.',
        errorGoogleUnavailable: 'שירות Google לא זמין כרגע',
        errorEnterEmail: 'נא להזין כתובת אימייל',
        errorSendCode: 'שגיאה בשליחת קוד',
        errorEnterCode: 'נא להזין קוד בן 6 ספרות',
        errorResetPassword: 'שגיאה באיפוס הסיסמה',
        and: 'ול',
        rememberMe30: 'זכור אותי למשך 30 יום',
        keepLoggedInForever: 'השאר אותי מחובר לתמיד במכשיר זה',
        keepLoggedInHint: 'מומלץ לטלפון נייד אישי. לא להשתמש במחשב משותף.',
    },

    // ==================== LAYOUT ====================
    layout: {
        dashboard: 'לוח בקרה',
        webmail: 'תיבת דואר',
        calendar: 'לוח שנה',
        orgManagement: 'ניהול ארגון',
        organizations: 'ארגונים',
        domains: 'דומיינים',
        mailboxes: 'תיבות מייל',
        users: 'משתמשים',
        operations: 'תפעול וכספים',
        plans: 'חבילות ונפחים',
        proposals: 'הצעות מחיר',
        billing: 'חיוב וחשבונות',
        branding: 'מיתוג',
        monitoring: 'ניטור ואבטחה',
        reports: 'דוחות ולוגים',
        systemHealth: 'בריאות מערכת',
        auditLog: 'יומן ביקורת',
        tools: 'כלים',
        aiAgent: 'סוכן AI אישי',
        automations: 'אוטומציות AI',
        filing: 'תיוק מסמכים',
        smartCleanup: 'ניקוי חכם AI',
        autoReplyLog: 'יומן מענה AI',
        migration: 'הגירת מיילים',
        marketingCockpit: 'קוקפיט שיווק',
        salesEngine: 'מנוע מכירות',
        integrations: 'אינטגרציות',
        settings: 'הגדרות',
        viewingAsUser: 'צפייה כמשתמש',
        backToAdmin: 'חזור לאדמין',
        viewingAsUserClick: 'צפייה כמשתמש - לחץ לחזור',
        website: 'האתר',
        backToWebsite: 'חזרה לאתר',
        help: 'עזרה',
        helpCenter: 'מרכז עזרה',
        helpTooltip: 'מרכז עזרה והדרכה',
        darkMode: 'מצב כהה',
        lightMode: 'מצב בהיר',
        expandMenu: 'הרחב תפריט',
        collapseMenu: 'מזער תפריט',
        logout: 'התנתק',
        language: 'שפה',
        roles: {
            super_admin: 'מנהל ראשי',
            multi_org_admin: 'מנהל ארגונים',
            org_admin: 'מנהל ארגון',
            user: 'משתמש',
        },
    },

    // ==================== SMART CLEANUP ====================
    cleanup: {
        title: 'סוכן ניקוי חכם AI',
        subtitle: 'סריקה חכמה של תיבת הדואר: זיהוי ניוזלטרים, ספאם, מיילים ישנים, כבדים וכפילויות. אפשרות להסרה מניוזלטרים, מחיקה, העברה לתיקיות וניקוי חכם.',
        startScan: 'התחל סריקה',
        scanning: 'סורק...',
        errorScan: 'שגיאה בהתחלת סריקה',
        errorScanResult: 'שגיאה בסריקה',
        noAccountTitle: 'יש לחבר חשבון מייל כדי להשתמש בסוכן הניקוי',
        noAccountSubtitle: 'עבור לדואר נכנס וחבר תיבת מייל קודם',
        readyTitle: 'מוכן לנקות את תיבת הדואר?',
        readySubtitle: 'הסוכן החכם יסרוק את התיבה, ימצא ניוזלטרים, ספאם, מיילים ישנים וכבדים, ויציע לך פעולות ניקוי חכמות. אפשר לבחור מה למחוק, להעביר או לארכב.',
        startSmartScan: 'התחל סריקה חכמה',
        newsletters: 'ניוזלטרים',
        newslettersDesc: 'מיילים עם אפשרות הסרה',
        spam: 'ספאם',
        spamDesc: 'מיילים חשודים כספאם',
        old: 'ישנים (6+ חודשים)',
        oldDesc: 'מיילים ישנים מעל חצי שנה',
        large: 'כבדים (5MB+)',
        largeDesc: 'מיילים עם קבצים גדולים',
        notifications: 'התראות מערכת',
        notificationsDesc: 'הודעות אוטומטיות',
        duplicates: 'כפילויות',
        duplicatesDesc: 'מיילים עם נושא זהה',
        deselectAll: 'בטל בחירה',
        selectAll: 'בחר הכל',
        selected: 'נבחרו',
        deleteSelected: 'מחק נבחרים',
        deleteBtn: 'מחק',
        moveToFolder: 'העבר לתיקייה',
        moveBtn: 'העבר',
        archive: 'ארכיון',
        markSpam: 'סמן כספאם',
        spamBtn: 'ספאם',
        markRead: 'סמן כנקרא',
        readBtn: 'נקרא',
        page: 'עמוד',
        noneFound: 'לא נמצאו מיילים בקטגוריה זו',
        unsubscribe: 'הסרה',
        unsubscribeTooltip: 'הסר מרשימת תפוצה',
        deleteConfirmTitle: 'אישור מחיקה',
        deleteConfirmMsg: 'פעולה זו תמחק {count} מיילים. לא ניתן לשחזר מיילים שנמחקו.',
        deleteCount: 'מחק {count} מיילים',
        moveTitle: 'העברה לתיקייה',
        movePrompt: 'בחר תיקיית יעד להעברת {count} מיילים:',
        folderName: 'שם תיקייה',
        folderPlaceholder: 'למשל: ניוזלטרים, לקוחות, ארכיון...',
        folderHelper: 'הקלד שם תיקייה קיימת או חדשה',
        executedResult: 'בוצע: {success} הצליחו, {failed} נכשלו',
        errorExecute: 'שגיאה בביצוע פעולה',
        rescan: 'סרוק מחדש',
        loadingCached: 'טוען תוצאות סריקה קודמת...',
        cachedLabel: 'שמור',
        lastScanAt: 'סריקה אחרונה: {date}',
        insightsSummary: 'נסרקו {total} מיילים · נמצאו {items} פריטים לטיפול',
        organizeBtn: 'ארגן לתיקיות',
        organizeTooltip: 'העבר אוטומטית ניוזלטרים, התראות וספאם לתיקיות מסודרות',
        organizeTitle: 'ארגון אוטומטי לתיקיות',
        organizeDesc: 'הסוכן החכם יעביר אוטומטית מיילים לתיקיות מסודרות לפי הסיווג שנמצא בסריקה:',
        organizeInfo: 'תיקיות שלא קיימות ייווצרו אוטומטית. מיילים שהועברו יצאו מה-INBOX.',
        organizeComplete: 'הארגון הושלם בהצלחה!',
        organizeSuccess: 'ה-INBOX אורגן בהצלחה לתיקיות',
        organizing: 'מארגן...',
        organizeNow: 'ארגן עכשיו',
        errorOrganize: 'שגיאה בארגון לתיקיות',
        movedToFolder: 'הועברו לתיקייה',
        failedItems: 'נכשלו',
        foldersCreated: 'תיקיות שנוצרו',
    },

    // ==================== CALENDAR ====================
    calendar: {
        days: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
        daysShort: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
        months: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
        newEvent: 'אירוע חדש',
        editEvent: 'עריכת אירוע',
        title: 'כותרת',
        descriptionLabel: 'תיאור',
        location: 'מיקום',
        start: 'התחלה',
        end: 'סיום',
        allDay: 'כל היום',
        color: 'צבע:',
        month: 'חודש',
        week: 'שבוע',
        day: 'יום',
        addEvent: 'הוסף אירוע',
        eventCreated: 'אירוע נוצר בהצלחה',
        eventUpdated: 'האירוע עודכן',
        eventDeleted: 'האירוע נמחק',
        eventMoved: 'האירוע הועבר',
        undo: 'בטל',
        redo: 'בצע שוב',
        undoDone: 'הפעולה בוטלה',
        redoDone: 'הפעולה בוצעה שוב',
        undoFailed: 'לא ניתן לבטל',
        redoFailed: 'לא ניתן לבצע שוב',
        deleteEvent: 'למחוק את האירוע?',
        errorSaving: 'שגיאה בשמירה',
        errorDeleting: 'שגיאה במחיקה',
        requiredFields: 'נדרש כותרת, תאריך התחלה ותאריך סיום',
        noReminder: 'ללא תזכורת',
        min5: '5 דקות לפני',
        min10: '10 דקות לפני',
        min15: '15 דקות לפני',
        min30: '30 דקות לפני',
        hour1: 'שעה לפני',
        hour2: 'שעתיים לפני',
        day1: 'יום לפני',
        once: 'חד-פעמי',
        daily: 'יומי',
        weekly: 'שבועי',
        monthly: 'חודשי',
        yearly: 'שנתי',
        printCalendar: 'הדפסת יומן',
        printPrompt: 'בחר תצוגה להדפסה:',
        dailyView: 'יומי',
        weeklyView: 'שבועי',
        monthlyView: 'חודשי',
        yearlyView: 'שנתי',
        yearLabel: 'שנת',
        weekLabel: 'שבוע',
        printWindowBlocked: 'חלון ההדפסה נחסם - אפשר חלונות קופצים',
        syncCalendar: 'סנכרון יומן',
        syncTooltip: 'סנכרון Google / Outlook / iCal',
        subscriptionUrl: 'כתובת מנוי (iCal)',
        subscriptionHelper: 'העתק את הכתובת והוסף כיומן חיצוני (חד־כיווני החוצה). לא לגוגל אם כבר מחוברים ב-OAuth.',
        copy: 'העתק',
        regenerate: 'חדש',
        syncUrlCopied: 'כתובת הסנכרון הועתקה',
        syncUrlRegenerated: 'כתובת סנכרון חדשה נוצרה',
        exportIcs: 'ייצוא ICS',
        importIcs: 'ייבוא ICS',
        exportDone: 'הקובץ הורד',
        importDone: 'יובאו {count} אירועים',
        errorExport: 'שגיאה בייצוא',
        errorImport: 'שגיאה בייבוא',
        exportImport: 'ייצוא / ייבוא',
        externalSyncTitle: 'סנכרון דו־כיווני אוטומטי',
        externalSyncHelper: 'חברו Google Calendar או Outlook — האירועים יופיעו כאן ויתעדכנו אוטומטית לשני הכיוונים.',
        connectGoogle: 'חבר Google Calendar',
        connectOutlook: 'חבר Outlook',
        disconnectGoogle: 'נתק Google',
        disconnectOutlook: 'נתק Outlook',
        syncNow: 'סנכרן עכשיו',
        syncDone: 'הסנכרון הושלם',
        syncFailed: 'הסנכרון נכשל',
        connectedAs: 'מחובר כ־{email}',
        lastSync: 'סנכרון אחרון: {time}',
        sourceGoogle: 'Google',
        sourceOutlook: 'Outlook',
        sourceLocal: 'מקומי',
        notConfiguredGoogle: 'Google Calendar לא מוגדר בשרת (OAuth)',
        notConfiguredOutlook: 'Outlook Calendar לא מוגדר בשרת (OAuth)',
        calendarHint: 'Email Lion - יומן',
        aiAgent: 'סוכן יומן AI',
        aiAgentTooltip: 'סוכן AI חכם',
        aiHello: 'שלום! אני סוכן היומן שלך',
        aiSubtitle: 'ספר לי בשפה חופשית מה לתזמן',
        aiPlaceholder: 'ספר לי מה לתזמן ואני אטפל בזה',
        aiInputPlaceholder: 'לדוגמה: "ישיבת צוות ביום חמישי ב-15:00"',
        aiDaySummary: 'סיכום היום',
        aiThinking: 'חושב...',
        voiceInputTooltip: 'הקלד קולית',
        voiceStop: 'עצור הקלטה',
        voiceListening: 'מאזין... דבר עכשיו',
        voiceNotSupported: 'הקלטה קולית אינה נתמכת בדפדפן זה',
        aiErrorSummary: 'שגיאה בקבלת סיכום יום',
        requestProcessed: 'הבקשה עובדה בהצלחה.',
        eventsCreated: 'נוצרו {count} אירועים:',
        more: 'עוד',
        reminder: 'תזכורת',
        reminderSnack: '🔔 תזכורת: {title} ב-{time}',
        reminderBody: 'ב-{time}',
        aiCreatedEvents: '📅 נוצרו {count} אירועים:',
        aiNoResponse: 'לא קיבלתי תגובה.',
        aiSummaryPrefix: '📊 סיכום {date}:',
        aiNoInfo: 'אין מידע',
        aiExampleChip: 'פגישה מחר ב-10',
        aiExampleChipPrompt: 'קבע לי מחר בעשר בבוקר פגישה בתל אביב עם הספק',
        aiExample1: 'קבע לי מחר בעשר בבוקר פגישה בתל אביב',
        aiExample2: 'צור 3 תזכורות שבועיות: סקירה, צוות, וסיכום',
        aiExample3: 'ישיבת הנהלה דחופה היום ב-16:00 + תזכורת',
        syncCopyTooltip: 'העתק',
        syncRegenerateTooltip: 'חדש',
        syncGoogleInstructions: 'הגדרות - הוסף יומן - מכתובת URL',
        syncAppleInstructions: 'קובץ - מנוי חדש',
        syncOutlookInstructions: 'הוסף יומן - הירשם מהאינטרנט',
        icalGoogleWarning: 'כבר מחוברים ל-Google Calendar בסנכרון דו־כיווני. אל תוסיפו את קישור ה-iCal לגוגל — זה יוצר כפילות לכל אירוע. הסירו בסרגל השמאלי של Google Calendar את הסימון מיומן "Email Lion Calendar". קישור iCal מיועד ל-Apple Calendar או ליומן אחר בלבד.',
        dedupeButton: 'נקה כפילויות',
        dedupeConfirm: 'למחוק שורות כפולות ביומן של אימייליון (אותו אירוע פעמיים)? האירועים בגוגל עצמו לא יימחקו — אם הכפילות שם, הסירו את היומן "Email Lion Calendar" בסרגל השמאלי.',
        dedupeDone: 'הוסרו {count} כפילויות',
        dedupeNone: 'לא נמצאו כפילויות ביומן של אימייליון',
        aiClearChat: 'נקה שיחה',
        aiClearConfirm: 'לנקות את היסטוריית השיחה עם הסוכן?',
    },

    // ==================== AUTOMATIONS ====================
    automations: {
        title: 'אוטומציות AI על מיילים',
        subtitle: 'צור כללים אוטומטיים לעיבוד מיילים עם AI - חילוץ נתונים, סיכומים, חישובים ועוד',
        moduleTitle: 'אוטומציות AI על מיילים',
        moduleDesc: 'עבדו חכם יותר — הגדירו כללים שמעבדים מיילים וקבצים מצורפים עם AI באופן אוטומטי. חילוץ נתונים מ-PDF, סיכום מסמכים, חישובים על Excel, ועוד.',
        moduleFeatures: ['עיבוד PDF/Excel/CSV', 'סיכום מסמכים', 'חילוץ נתונים', 'שליחה למייל/Webhook', '3 מנועי AI'],
        newAutomation: 'אוטומציה חדשה',
        editAutomation: 'עריכת אוטומציה',
        runAllNow: 'הרץ עכשיו',
        runAllTooltip: 'הרץ את כל האוטומציות עכשיו',
        runningInBackground: 'האוטומציות רצות כעת ברקע...',
        errorRunning: 'שגיאה בהפעלה',
        totalAutomations: 'סה"כ אוטומציות',
        active: 'פעילות',
        runs30days: 'הרצות (30 יום)',
        successRate: 'אחוז הצלחה',
        tabMy: 'האוטומציות שלי',
        tabHistory: 'היסטוריית הרצות',
        tabTemplates: 'תבניות מוכנות',
        noAutomations: 'אין אוטומציות עדיין. צור את הראשונה או בחר מתבנית!',
        noRuns: 'אין הרצות עדיין',
        filters: 'פילטרים',
        output: 'פלט',
        runsCount: 'הרצות',
        lastRun: 'הרצה אחרונה',
        outputEmail: 'שליחה במייל',
        outputWebhook: 'Webhook (Zapier/Make)',
        outputDownload: 'הורדה כ-PDF',
        outputEmailWebhook: 'מייל + Webhook',
        formatText: 'טקסט חופשי',
        formatJson: 'JSON מובנה',
        formatTable: 'טבלה',
        formatSummary: 'סיכום נקודות',
        statusSuccess: 'הצלחה',
        statusFailed: 'נכשל',
        statusProcessing: 'מעבד...',
        statusSkipped: 'דולג',
        automationUpdated: 'אוטומציה עודכנה',
        automationCreated: 'אוטומציה נוצרה',
        automationDeleted: 'אוטומציה נמחקה',
        deleteConfirm: 'למחוק את האוטומציה?',
        testCompleted: 'בדיקה הושלמה בהצלחה',
        testTimeout: 'הבדיקה ארכה יותר מדי זמן. נסה שוב.',
        testConnectionLost: 'החיבור לשרת נותק. השרת עשוי להיות בתהליך הפעלה מחדש – נסה שוב בעוד 30 שניות.',
        testFailed: 'בדיקה נכשלה – בדוק הגדרות AI ותיבת מייל',
        downloadPdfError: 'שגיאה בהורדת PDF',
        useTemplate: 'השתמש בתבנית',
        downloadPdf: 'הורד כ-PDF',
        stepTrigger: 'טריגר ופילטרים',
        stepAi: 'עיבוד AI',
        stepOutput: 'פלט ומשלוח',
        automationName: 'שם האוטומציה',
        descriptionOptional: 'תיאור (אופציונלי)',
        filterFrom: 'מאת (כתובת או חלק ממנה, ניתן להשתמש ב-/regex/)',
        filterFromHelper: 'ניתן להפריד בפסיקים מספר כתובות. דוגמה: accounting@, billing@company.com או /.*@company\\.co\\.il/',
        filterSubject: 'נושא מכיל (מילות מפתח מופרדות בפסיק)',
        filterSubjectHelper: 'דוגמה: חשבונית,invoice,קבלה',
        filterBody: 'תוכן מכיל (מילות מפתח)',
        blockedSenders: 'כתובות חסומות מהאוטומציה',
        blockedSendersHelper: 'כתובות מייל או דומיינים שיחסמו, מופרדים בפסיק. דוגמה: spam@example.com, noreply@domain.com',
        onlyWithAttachment: 'רק מיילים עם קובץ מצורף',
        fileType: 'סוג קובץ',
        fileTypeAll: 'הכל',
        fileTypeImage: 'תמונה',
        fileTypeAny: 'כל סוג',
        aiEngine: 'מנוע AI',
        aiDefault: 'ברירת מחדל (מהגדרות)',
        aiOpenai: 'OpenAI (GPT-4o) - מומלץ לאקסל',
        aiAnthropic: 'Anthropic (Claude) - מומלץ ל-PDF',
        aiGoogle: 'Google (Gemini) - מהיר ויעיל',
        outputFormat: 'פורמט פלט',
        aiPrompt: 'פרומפט AI (ההנחיות לעיבוד)',
        aiPromptHelper: 'ניתן להשתמש במשתנים: {email_body}, {attachment_content}, {sender}, {subject}, {date}',
        includeBody: 'כלול גוף מייל',
        includeAttachments: 'כלול קבצים מצורפים',
        aiTips: 'טיפים:',
        aiTipsText: 'Claude מצטיין בקריאת PDF מורכבים. GPT-4o מצטיין בניתוח טבלאות ומספרים. Gemini מהיר ויעיל לעיבוד גדול.',
        outputType: 'סוג פלט',
        sendTarget: 'יעד שליחה',
        sendToSelf: 'החשבון שלי (ברירת מחדל)',
        sendToSender: 'שלח חזרה לשולח המייל',
        sendToCustom: 'כתובת מותאמת אישית',
        customEmail: 'כתובת מייל מותאמת',
        customEmailHelper: 'לדוגמה: ops@company.com',
        emailSubjectTemplate: 'תבנית נושא המייל',
        emailSubjectHelper: 'ניתן להשתמש ב: {subject}, {automation_name}',
        attachAsPdf: 'צרף תוצאה כ-PDF',
        webhookHeaders: 'Webhook Headers (JSON, אופציונלי)',
        webhookInfo: 'ה-Webhook ישלח JSON עם שדות: automation_name, trigger (from, subject, date), result (text, format). אם פורמט הפלט הוא JSON, השדה result.parsed יכיל את ה-JSON המפורסר.',
        limits: 'הגבלות',
        maxRunsPerDay: 'מקסימום הרצות ליום',
        activeHoursStart: 'שעת התחלה',
        activeHoursEnd: 'שעת סיום',
        enableImmediately: 'הפעל אוטומציה מיד לאחר שמירה',
        testResultTitle: 'תוצאת בדיקה',
        aiResult: 'תוצאת AI:',
        sentTo: 'נשלח אל:',
        inputSentToAi: 'קלט שהועבר ל-AI:',
        processingTime: 'זמן עיבוד:',
        testedWithReal: 'נבדק עם מייל אמיתי',
        testedWithMock: 'נבדק עם מייל דמה (לא נמצא מייל אמיתי בתיבה)',
        createAutomation: 'צור אוטומציה',
        fromFilter: 'מאת:',
        subjectFilter: 'נושא:',
        attachment: 'צרופה',
        // Multi-output (filing / cloud)
        additionalOutputs: 'יעדים נוספים',
        fileToCloud: 'תייק גם ב-Google Drive / Dropbox / OneDrive',
        filingConnection: 'חיבור תיוק',
        filingFolderPath: 'נתיב תיקיית יעד (אופציונלי)',
        filingFolderHelper: 'מופרד ב-"/". תומך במשתנים: {date}, {subject}, {from_name}, {automation_name} ושדות JSON של פלט ה-AI.',
        fileAttachments: 'תייק קבצים מצורפים',
        fileEmailBody: 'תייק את גוף המייל',
        fileAiResult: 'תייק את תוצאת ה-AI',
        noFilingConnections: 'אין חיבור פעיל ל-Google Drive, Dropbox או OneDrive. הוסף חיבור בדף "תיוק" כדי להפעיל אפשרות זו.',
        filingNeedsConnection: 'יש לבחור חיבור Drive/Dropbox/OneDrive כדי להפעיל תיוק כפלט.',
        emailBodyTemplate: 'תבנית גוף המייל (אופציונלי)',
        emailBodyHelper: 'אם ריק - גוף המייל יהיה פלט ה-AI כפי שהוא. תומך באותם משתנים כמו שורת הנושא.',
        templateVarsHelper: 'משתנים זמינים: {subject}, {from_name}, {from}, {date}, {date:dd/MM}, {ai_result} (גם {ai_text}). אם פלט ה-AI הוא JSON גם {{ספק}}, {{סכום}}, {ai_json.amount} וכו\'.',
        // Workflow output targets
        createTaskOption: 'צור משימה אוטומטית (Task Manager)',
        generateReplyDraftOption: 'הכן טיוטת תגובה לאישור (Smart Reply)',
        sendAlertOption: 'שלח התראה דחופה (Alert)',
        taskDefaultStatus: 'סטטוס ברירת מחדל',
        taskDefaultPriority: 'עדיפות',
        taskDefaultTags: 'תגיות (מופרדות בפסיק)',
        taskStatusOpen: 'פתוח',
        taskStatusUrgent: 'דחוף',
        taskStatusWaitingSupplier: 'ממתין לספק',
        taskStatusWaitingCustomer: 'ממתין ללקוח',
        taskPriorityLow: 'נמוכה',
        taskPriorityMedium: 'בינונית',
        taskPriorityHigh: 'גבוהה',
        taskPriorityUrgent: 'דחוף',
        taskJsonHint: 'טיפ: כדי שה-AI יקבע באופן דינמי כותרת/סטטוס/עדיפות, הגדר ai_output_format=json ובקש בפרומפט להחזיר { title, summary, status, priority, tags, followup_hours }.',
        replyDraftDefaultTo: 'ברירת מחדל לנמען',
        replyDraftDefaultToHelper: 'השאר "__sender__" כדי לענות לשולח המקורי, או הזן אימייל קבוע.',
        alertRecipientsLabel: 'נמעני התראה (מופרדים בפסיק)',
        alertRecipientsHelper: 'אם ריק - ההתראה תישלח לחשבון של האוטומציה. בנוסף תישלח push notification למשתמש.',
        // Trigger types
        triggerSection: 'טריגר',
        triggerType: 'סוג טריגר',
        triggerEmail: 'מייל נכנס (ברירת מחדל)',
        triggerSchedule: 'לפי זמן (סיכום יומי / דוח)',
        triggerFollowup: 'Follow-Up אוטומטי על משימות פתוחות',
        scheduleTime: 'שעת הפעלה',
        scheduleDays: 'ימים פעילים',
        scheduleDaysHelper: '0=ראשון, 1=שני, ..., 6=שבת',
        followupWaitHours: 'כמה שעות להמתין לפני follow-up',
        followupWaitHelper: 'האוטומציה תיגרור follow-up למשימות שלא היה בהן עדכון תקופה זו',
        scheduleTimeInvalid: 'שעת ההפעלה חייבת להיות בפורמט HH:MM',
        followupWaitInvalid: 'עבור טריגר Follow-Up יש להזין מספר שעות חיובי',
        // Reference materials (knowledge base files attached to the prompt)
        referenceMaterials: 'חומרי עזר קבועים לאוטומציה',
        referenceMaterialsHelper: 'קבצי עזר או קישורים שיצורפו לכל הרצה של האוטומציה. שימושי לטבלאות מינימום הזמנה, מחירונים, רשימות לקוחות וכו\'. גליונות גוגל ציבוריים יורדו אוטומטית כ-CSV.',
        addReferenceMaterial: 'הוסף חומר עזר',
        referenceMaterialName: 'שם תיאורי',
        referenceMaterialUrl: 'קישור (Google Sheet / Drive / URL ישיר)',
        referenceMaterialUrlHelper: 'גליון Google ציבורי יורד כ-CSV אוטומטית. עבור קובץ ב-Drive פרטי, פתח אותו לכל מי שיש לו את הקישור.',
        referenceMaterialRemove: 'הסר',
        // Task manager
        tasksTitle: 'משימות פתוחות',
        taskUpdated: 'משימה עודכנה',
        taskUpdateError: 'שגיאה בעדכון משימה',
        taskDeleteConfirm: 'למחוק את המשימה? פעולה זו אינה הפיכה.',
        taskDeleted: 'משימה נמחקה',
        taskDeleteError: 'שגיאה במחיקה',
        taskFilterOpenOnly: 'פתוחות בלבד',
        taskFilterUrgent: 'דחופות',
        taskFilterOpen: 'פתוחות',
        taskFilterWaitingSupplier: 'ממתינות לספק',
        taskFilterWaitingCustomer: 'ממתינות ללקוח',
        taskFilterClosed: 'סגורות',
        taskFilterAll: 'הכל',
        tasksCount: '{count} משימות',
        taskColTitle: 'כותרת / סיכום',
        taskColSource: 'מקור',
        taskColAutomation: 'אוטומציה',
        taskColLastAction: 'פעולה אחרונה',
        noOpenTasks: 'אין משימות פתוחות כרגע',
        tasksAutoInfo: 'משימות שנוצרות אוטומטית ממיילים יופיעו כאן.',
        taskStatusClosed: 'סגור',
        taskPrioUrgent: 'דחוף',
        taskPrioHigh: 'גבוה',
        taskPrioMedium: 'בינוני',
        taskPrioLow: 'נמוך',
        taskReopen: 'פתח מחדש',
        taskCloseTask: 'סגור משימה',
        taskShowMore: 'הצג הכל',
        taskShowLess: 'הצג פחות',
        taskViewFull: 'פרטים מלאים',
        taskSummaryFull: 'סיכום מלא',
        taskNoSummary: 'אין סיכום למשימה זו',
        taskStatusStuck: 'תקוע',
        refNamePlaceholder: 'טבלת מינימום הזמנה',
        emailBodyPlaceholder: 'דוגמה: שלום,\nחשבונית חדשה מ-{from_name}.\nספק: {{ספק}}, סכום: {{סכום}}.\n\n{ai_result}',
        filingPathPlaceholder: '{date}/אוטומציות/{from_name}',
        refMaterialsLoadedSummary: 'חומרי עזר: {ok}/{total} נטענו',
        extractWarningPrefix: 'שגיאה בטעינת תוכן המייל / קבצים:',
        refMaterialsLoadedTitle: 'חומרי עזר קבועים שנטענו ({ok}/{total})',
        downloadedFile: 'קובץ שהורד:',
        refMaterialChip: 'חומר עזר',
    },

    // ==================== FILING ====================
    filing: {
        title: 'תיוק מסמכים חכם',
        subtitle: 'תייקו קבצים מצורפים מהמייל אוטומטית לענן עם AI',
        skippedNoDocument: 'לא נמצא מסמך להורדה בקישור',
        retryFailedBtn: 'נסה שוב (נכשלו)',
        retryFailedSuccess: 'משימות שנכשלו הועברו לניסיון חוזר',
        retryFailedError: 'שגיאה באיפוס משימות',
        moduleDesc: 'תייקו מסמכים מצורפים מהמייל ישירות לגוגל דרייב, דרופבוקס או OneDrive — באופן אוטומטי עם AI. המערכת מזהה חשבוניות, הזמנות, חוזים ועוד, ומתייקת אותם בתיקיות מסודרות.',
        moduleFeatures: ['Google Drive', 'Dropbox', 'OneDrive', 'זיהוי מסמכים AI', 'תיקיות אוטומטיות', 'סינון חכם'],
        newRule: 'כלל תיוק חדש',
        editRule: 'עריכת כלל תיוק',
        activeRules: 'כללים פעילים',
        filesFiled: 'קבצים תויקו',
        todayFilings: 'תיוקים היום',
        cloudConnections: 'חיבורי ענן',
        tabConnections: 'חיבורי ענן',
        tabRules: 'כללי תיוק',
        tabHistory: 'היסטוריה',
        googleDriveDesc: 'תייקו קבצים מצורפים ישירות לגוגל דרייב. המערכת תיצור תיקיות באופן אוטומטי לפי הגדרות ה-AI.',
        dropboxDesc: 'תייקו קבצים מצורפים ישירות לדרופבוקס. המערכת תיצור תיקיות באופן אוטומטי לפי הגדרות ה-AI.',
        onedriveDesc: 'תייקו קבצים מצורפים ישירות ל-OneDrive של Microsoft. המערכת תיצור תיקיות באופן אוטומטי לפי הגדרות ה-AI.',
        notConnected: 'לא מחובר',
        disconnect: 'נתק חיבור',
        connectGoogleDrive: 'חבר Google Drive',
        connectDropbox: 'חבר Dropbox',
        connectOneDrive: 'חבר OneDrive',
        connectedSuccess: 'חובר בהצלחה!',
        connectionError: 'שגיאה בחיבור:',
        connectFirst: 'חבר חשבון Google Drive, Dropbox או OneDrive כדי להתחיל לתייק מסמכים אוטומטית.',
        noRules: 'אין כללי תיוק',
        noRulesSubtitle: 'צור כלל תיוק ראשון כדי להתחיל לתייק מסמכים אוטומטית מהמייל.',
        connectCloudFirst: 'יש לחבר קודם חשבון ענן (Google Drive, Dropbox או OneDrive) בלשונית "חיבורי ענן"',
        allEmails: 'כל המיילים עם קבצים',
        runsToday: 'ריצות היום',
        noHistory: 'אין היסטוריית תיוק',
        noHistorySubtitle: 'ברגע שכללי תיוק יפעלו, תראו כאן את ההיסטוריה.',
        filterByRule: 'סינון לפי כלל',
        filterBySender: 'סינון לפי שולח',
        allRules: 'כל הכללים',
        applyFilters: 'סנן',
        clearFilters: 'נקה סינון',
        loadMore: 'טען עוד',
        showingXofY: 'מציג {shown} מתוך {total}',
        rule: 'כלל',
        sender: 'שולח',
        filesCount: 'קבצים',
        disconnectConfirm: 'האם אתה בטוח? כללי תיוק שמשתמשים בחיבור זה יפסיקו לעבוד.',
        connectionRemoved: 'חיבור הוסר',
        errorDisconnect: 'שגיאה במחיקת חיבור',
        errorConnection: 'שגיאה בחיבור',
        ruleUpdated: 'כלל עודכן',
        ruleCreated: 'כלל נוצר בהצלחה',
        ruleDeleted: 'כלל נמחק',
        deleteRuleConfirm: 'האם למחוק כלל תיוק זה?',
        errorToggle: 'שגיאה בשינוי מצב',
        manualRunStarted: 'ריצה ידנית הושקה',
        errorManualRun: 'שגיאה בהשקת ריצה ידנית',
        testResult: 'תוצאת בדיקה',
        aiClassified: 'AI סיווג את המסמך בהצלחה (ביטחון: {confidence}%)',
        emailLabel: 'מייל:',
        fileLabel: 'קובץ:',
        docType: 'סוג מסמך:',
        filingPath: 'נתיב תיוק:',
        filePath: 'נתיב',
        fileLink: 'קישור',
        fileName: 'שם קובץ:',
        destination: 'יעד:',
        stepSource: 'מקור וסינון',
        stepAi: 'הוראות AI',
        stepDestination: 'יעד ומגבלות',
        ruleName: 'שם כלל התיוק',
        imapFolder: 'תיקיית IMAP',
        imapDefault: 'ברירת מחדל: INBOX',
        filterOptional: 'סינון (אופציונלי)',
        filterFrom: 'מאת (שולח)',
        filterFromHelper: 'כתובת מייל, חלק ממנה, או מופרד בפסיק. השאר ריק = כל השולחים',
        filterSubject: 'נושא מכיל',
        filterSubjectHelper: 'מילות מפתח בנושא, מופרד בפסיק',
        filterBody: 'תוכן המייל מכיל',
        filterAttachment: 'שם קובץ מצורף מכיל',
        filterAttachmentHelper: 'למשל: "חשבונית", "invoice", "הזמנה"',
        blockedSenders: 'כתובות חסומות מהתיוק',
        blockedSendersHelper: 'כתובות מייל או דומיינים שיחסמו, מופרדים בפסיק. דוגמה: spam@example.com, noreply@domain.com',
        aiInstructions: 'תאר ל-AI איך אתה רוצה שהמסמכים יתויקו. אם תשאיר ריק, ה-AI ישתמש בשיטת ברירת מחדל: שנה > שם שולח > סוג מסמך (חשבונית/הזמנה/חוזה/כללי).',
        filingPrompt: 'הנחיות תיוק (Prompt) — אופציונלי',
        filingPromptPlaceholder: 'דוגמאות:\n\n• "סדר בתיקיות לפי: שנה > שם לקוח > סוג מסמך (חשבוניות, הזמנות, חוזים)"\n\n• "תייק הכל בתיקייה אחת בשם \'מסמכים נכנסים\' עם תאריך כקידומת"\n\n• "חשבוניות של ספקים בתיקיית \'הוצאות > שנה > חודש\', חשבוניות ללקוחות בתיקיית \'הכנסות > שנה\'"\n\n• "קבצי PDF שמכילים \'invoice\' - תיקיית חשבוניות. קבצי Excel - תיקיית דוחות. השאר - תיקיית כללי"',
        aiEngineOptional: 'מנוע AI (אופציונלי)',
        modelOptional: 'מודל (אופציונלי)',
        modelHelper: 'השאר ריק לשימוש במודל ברירת המחדל',
        cloudTarget: 'יעד ענן',
        targetFolder: 'תיקיית יעד:',
        rootFolder: 'תיקייה ראשית (שורש)',
        resetToRoot: 'איפוס לתיקייה ראשית',
        browseFolder: 'בחר תיקייה / צור תיקייה חדשה',
        limitsLabel: 'מגבלות',
        maxRunsDay: 'מקסימום ריצות ביום',
        startHour: 'שעת התחלה',
        endHour: 'שעת סיום',
        activeDays: 'ימים פעילים:',
        enableAfterCreate: 'הפעל כלל מיד לאחר יצירה',
        selectFolder: 'בחר תיקיית יעד',
        noSubfolders: 'אין תת-תיקיות כאן',
        noFolders: 'אין תיקיות',
        createOrSelect: 'צור תיקייה חדשה או בחר את התיקייה הנוכחית',
        newFolderName: 'שם תיקייה חדשה',
        createFolder: 'צור',
        folderCreated: 'תיקייה נוצרה בהצלחה',
        errorCreateFolder: 'שגיאה ביצירת תיקייה',
        selectThisFolder: 'בחר תיקייה זו',
        selectCloudFirst: 'בחר חיבור ענן קודם',
        nameRequired: 'יש למלא שם כלל',
        accountRequired: 'יש לבחור חשבון מייל',
        missingRuleName: 'חסר שם כלל (שלב 1)',
        missingAccount: 'חסר חשבון מייל (שלב 1)',
        missingCloud: 'חסר יעד ענן',
        createRule: 'צור כלל',
        fromPrefix: 'מ:',
        subjectPrefix: 'נושא:',
        filePrefix: 'קובץ:',
        daysShort: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
    },

    // ==================== INBOX (Webmail) ====================
    inbox: {
        compose: 'הודעה חדשה',
        reply: 'השב',
        replyAll: 'השב לכולם',
        forward: 'העבר',
        forwardAttachmentsFailed: 'קבצים מצורפים לא נטענו להעברה — נסה שוב או צרף אותם ידנית',
        to: 'אל',
        cc: 'העתק',
        bcc: 'העתק מוסתר',
        subject: 'נושא',
        noSubject: '(ללא נושא)',
        send: 'שלח',
        sending: 'שולח...',
        emailSent: 'המייל נשלח בהצלחה!',
        readReceipt: 'אישור קריאה',
        openTracking: 'מעקב פתיחה',
        priority: 'עדיפות',
        priorityHigh: 'עדיפות גבוהה',
        priorityNormal: 'רגיל',
        priorityLow: 'עדיפות נמוכה',
        encryption: 'הצפנה',
        schedule: 'תזמון',
        templates: 'תבניות',
        addAttachment: 'הוסף קובץ',
        attachments: 'קבצים מצורפים',
        dragFiles: 'גרור קבצים לכאן או לחץ "הוסף קובץ"',
        snooze: 'תזכורת / נודניק',
        snooze1h: 'עוד שעה',
        snooze3h: 'עוד 3 שעות',
        snoozeTomorrow: 'מחר בבוקר',
        snooze2d: 'עוד יומיים',
        snooze1w: 'עוד שבוע',
        addStar: 'סמן בכוכב',
        removeStar: 'הסר כוכב',
        selected: 'נבחרו',
        deleteSelected: 'מחק נבחרים',
        moveToArchive: 'העבר לארכיון',
        markRead: 'סמן כנקרא',
        markUnread: 'סמן כלא נקרא',
        moveToFolder: 'העבר לתיקייה',
        deselectAll: 'בטל בחירה',
        connecting: 'מתחבר לתיבת הדואר...',
        noResults: 'לא נמצאו תוצאות',
        emptyFolder: 'תיקייה ריקה',
        inbox: 'דואר נכנס',
        sentMail: 'נשלחו',
        drafts: 'טיוטות',
        spam: 'ספאם',
        trash: 'פח',
        archive: 'ארכיון',
        flagged: 'מסומנים',
        allMail: 'כל הדואר',
        primary: 'ראשי',
        social: 'חברתי',
        promotions: 'מבצעים',
        updates: 'עדכונים',
        quickReplyPlaceholder: 'תשובה מהירה...',
        sendQuickReply: 'שלח',
        quickReplySent: 'תשובה מהירה נשלחה!',
        composePlaceholder: 'כתוב את ההודעה שלך כאן...',
        addressPlaceholder: 'הקלד כתובת...',
        searchPlaceholder: 'חיפוש מיילים...',
        aiAssist: 'עזרה בניסוח עם AI',
        aiCompose: 'ניסוח עם AI',
        aiTones: {
            professional: 'מקצועי',
            friendly: 'ידידותי',
            brief: 'קצר',
            formal: 'רשמי',
            thankful: 'תודה',
            decline: 'סירוב מנומס',
        },
        aiTonesDesc: {
            professional: 'תגובה עניינית ומנומסת',
            friendly: 'חם ואישי',
            brief: 'ישר לעניין, 3-4 משפטים',
            formal: 'כמו מכתב עסקי',
            thankful: 'הבעת הערכה',
            decline: 'סירוב עדין עם חלופה',
        },
        errorSendingEmail: 'שגיאה בשליחת המייל',
        errorLoadingMessage: 'שגיאה בטעינת ההודעה',
        deleteConfirm: 'למחוק הודעות אלו?',
        newFolder: 'תיקייה חדשה',
        renameFolder: 'שנה שם',
        deleteFolder: 'מחק תיקייה',
        folderName: 'שם תיקייה',
        wrote: 'כתב/ה',
        forwardedMessage: 'הודעה מועברת',
        fromLabel: 'מאת:',
        dateLabel: 'תאריך:',
        subjectLabel: 'נושא:',
        printEmail: 'הדפס',
        downloadEmail: 'הורד',
        unifiedInbox: 'תיבה מאוחדת',
        newMail: 'דואר חדש',
        newMailBody: 'יש לך {count} הודעות חדשות',
        connectionError: 'שגיאה בהתחברות לתיבה',
        connectionCooldown: 'החיבור בהמתנה זמנית עקב כשלים קודמים. מנסה לאפס...',
        resetDone: 'האיפוס בוצע - מתחבר מחדש...',
        reconnectingAccount: 'שרת הדואר דחה את החיבור באופן זמני - מנסה להתחבר מחדש...',
        cannotAutoReset: 'לא ניתן לאפס אוטומטית - פנה למנהל',
        mailboxUnavailable: 'תיבה {email} לא זמינה כרגע, עוברים לתיבה אחרת...',
        errorLoadingMessages: 'שגיאה בטעינת ההודעות',
        errorLoadingUnified: 'שגיאה בטעינת תיבת דואר מאוחדת',
        errorAiReply: 'שגיאה ביצירת תגובת AI',
        errorAiCompose: 'שגיאה בניסוח AI',
        errorEncryption: 'שגיאה בהצפנה',
        sendWithoutEncryption: 'לשלוח ללא הצפנה?',
        errorSendingPrefix: 'שגיאה בשליחה: ',
        chooseDateTime: 'נא לבחור תאריך ושעה',
        emailScheduled: 'המייל תוזמן לשליחה בהצלחה!',
        errorSchedulingPrefix: 'שגיאה בתזמון: ',
        errorCreatingFolderPrefix: 'שגיאה ביצירת תיקייה: ',
        errorDeletingFolderPrefix: 'שגיאה במחיקת תיקייה: ',
        errorExportPrefix: 'שגיאה בייצוא: ',
        confirmDeleteSearch: 'האם למחוק את כל {count} ההודעות התואמות לחיפוש "{query}"?',
        errorDeletingSearchPrefix: 'שגיאה במחיקת כל תוצאות החיפוש: ',
        errorDeletingPrefix: 'שגיאה במחיקה: ',
        confirmEmptyFolder: 'האם לרוקן את "{folder}"? כל ההודעות ימחקו לצמיתות ולא ניתן יהיה לשחזר אותן.',
        errorEmptyingFolderPrefix: 'שגיאה בריקון התיקייה: ',
        confirmMoveSearch: 'האם להעביר את כל {count} ההודעות התואמות לחיפוש "{query}" לתיקייה?',
        errorMovingSearchPrefix: 'שגיאה בהעברת כל תוצאות החיפוש: ',
        errorMovingPrefix: 'שגיאה בהעברה: ',
        confirmSpamSearch: 'האם לדווח על כל {count} ההודעות התואמות כספאם?',
        errorSpamSearchPrefix: 'שגיאה בדיווח כל תוצאות החיפוש כספאם: ',
        confirmMoveToInbox: 'האם להעביר את כל {count} ההודעות התואמות לתיבת הדואר הנכנס?',
        errorMoveToInboxPrefix: 'שגיאה בהעברת כל תוצאות החיפוש לדואר נכנס: ',
        archiveNotFound: 'תיקיית ארכיון לא נמצאה',
        toLabel: 'אל:',
        ccLabel: 'העתק:',
        noName: 'ללא שם',
        lastMsg: 'אחרון',
        firstMsg: 'ראשון',
        noText: '(ללא טקסט)',
        noContent: '(ללא תוכן)',
        noMessageContent: 'אין תוכן להודעה זו.',
        pgpPassphrasePrompt: 'הזן את סיסמת ההצפנה (Passphrase):',
        noEncryptedContent: 'לא נמצא תוכן מוצפן',
        decryptedContent: 'תוכן מפוענח:',
        errorDecryption: 'שגיאה בפענוח',
        decrypt: 'פענח',
        pgpEncrypted: 'הודעה זו מוצפנת ב-PGP',
        readReceiptSent: 'אישור קריאה נשלח',
        errorSendingReadReceipt: 'שגיאה בשליחת אישור קריאה',
        sendConfirmation: 'שלח אישור',
        senderRequestedReadReceipt: 'השולח ביקש אישור קריאה להודעה זו',
        autoReplied: 'נענה אוטומטית',
        autoRepliedByAI: 'נענה אוטומטית על ידי AI',
        aiReplyTooltip: 'השב עם AI - יצירת תגובה אוטומטית',
        aiReplyLabel: 'AI השב',
        errorArchive: 'שגיאה בהעברה לארכיון',
        errorDelete: 'שגיאה במחיקה',
        notSpamTooltip: 'לא ספאם - העבר לדואר נכנס',
        reportSpamTooltip: 'דווח כספאם',
        createCalendarEvent: 'צור אירוע ביומן',
        openNewWindow: 'פתח בחלון חדש',
        exportEml: 'ייצוא כ-.eml',
        aiCategorize: 'סיווג אוטומטי (AI)',
        classifyResult: 'סיווג',
        errorClassify: 'שגיאה בסיווג אוטומטי',
        labelsTitle: 'תוויות',
        noLabelsHint: 'אין תוויות - צור בהגדרות',
        closePreview: 'סגור תצוגה מקדימה',
        snoozeSet: 'תזכורת נקבעה',
        errorSnooze: 'שגיאה בהגדרת תזכורת',
        emailFrom: 'מייל מ:',
        eventCreated: 'האירוע נוצר בהצלחה בלוח השנה!',
        errorCreatingEvent: 'שגיאה ביצירת אירוע',
        addAccount: '+ הוסף חשבון',
        demo: 'דמו',
        emptyAction: 'רוקן',
        welcomeTitle: 'ברוכים הבאים לתיבת הדואר',
        welcomeSubtitle: 'חבר את חשבון הדואר שלך כדי להתחיל לקבל ולשלוח הודעות. ניתן לחבר Gmail, Outlook, או כל חשבון IMAP.',
        connectMailbox: 'חבר תיבת דואר',
        connectHelpGuide: 'מדריך חיבור Gmail',
        connectHelpWhatsapp: 'עזרה ב-WhatsApp',
        connectBannerTitle: 'עדיין לא חיברתם תיבת מייל',
        connectBannerBody: 'בלי תיבה מחוברת אי אפשר לקרוא מיילים או להשתמש ב-AI. זה לוקח כדקה.',
        connectBannerCta: 'חבר תיבה עכשיו',
        connectBannerDismiss: 'אחר כך',
        tryAgain: 'נסה שוב',
        unread: 'לא נקראו',
        attachmentsFilter: 'קבצים',
        advancedSearch: 'סינון מתקדם',
        dateFrom: 'מתאריך',
        dateTo: 'עד תאריך',
        searchInBody: 'חיפוש בתוכן',
        clearFilters: 'נקה',
        paginationOf: 'מתוך',
        firstPage: 'עמוד ראשון',
        nextPage: 'עמוד הבא',
        prevPage: 'עמוד קודם',
        lastPage: 'עמוד אחרון',
        show: 'הצג:',
        autoRefresh: 'רענון אוטומטי',
        off: 'כבוי',
        seconds30: '30 שניות',
        minute1: 'דקה',
        minutes2: '2 דקות',
        minutes5: '5 דקות',
        createEventFromEmail: 'צור אירוע ביומן מהמייל',
        eventTitle: 'כותרת',
        eventDescription: 'תיאור',
        eventLocation: 'מיקום',
        eventStart: 'התחלה',
        eventEnd: 'סיום',
        createEventBtn: 'צור אירוע',
        addMailAccount: 'הוסף חשבון דואר',
        connectToMailbox: 'התחברות לתיבת דואר',
        loginPrompt: 'הזן את כתובת המייל והסיסמה. הפרטים יישמרו כדי שלא תצטרך להזין אותם שוב.',
        emailAddress: 'כתובת מייל',
        passwordLabel: 'סיסמה',
        useAppPassword: 'יש להשתמש ב-App Password (ראה מדריך למטה)',
        protocol: 'פרוטוקול',
        localStorage: 'שמירה מקומית',
        pop3Warning: 'מתאים לשרתים ישנים. מגבלות: תיקיית INBOX בלבד, ללא סנכרון סטטוס קריאה, ללא חיפוש בשרת.',
        localCacheInfo: 'הודעות יישמרו מקומית במכשיר לטעינה מהירה ולעבודה אופליין.',
        addAndConnect: 'הוסף וחבר',
        connect: 'התחבר',
        connectGmail: 'חיבור Gmail',
        connectOutlook: 'חיבור Outlook / Hotmail',
        connectYahoo: 'חיבור Yahoo Mail',
        connectWorkspace: 'חיבור Google Workspace / חשבון IMAP',
        openAppPasswords: 'פתח יצירת סיסמת אפליקציה ↗',
        copySetupLink: 'העתק קישור הגדרה',
        gmailAppPasswordInfo: 'Gmail דורש App Password (סיסמת אפליקציה) במקום הסיסמה הרגילה.',
        gmailStep1: 'היכנס ל-myaccount.google.com/security',
        gmailStep2: 'הפעל אימות דו-שלבי (2-Step Verification) אם לא פעיל',
        gmailStep3: 'חפש "App Passwords" (סיסמאות אפליקציה)',
        gmailStep4: 'צור סיסמה חדשה לאפליקציה "Mail" → העתק את הקוד בן 16 התווים',
        gmailStep5: 'הדבק את הקוד בשדה סיסמה למעלה (ללא רווחים)',
        outlookAppPasswordInfo: 'Outlook/Hotmail עם אימות דו-שלבי דורשים סיסמת אפליקציה (App Password).',
        outlookStep1: 'הפעל אימות דו-שלבי בחשבון Microsoft אם עדיין לא פעיל',
        outlookStep2: 'עבור ל-account.live.com/proofs/AppPassword',
        outlookStep3: 'צור סיסמת אפליקציה חדשה והעתק אותה',
        outlookStep4: 'הדבק את הסיסמה בשדה למעלה והתחבר ב-IMAP',
        yahooAppPasswordInfo: 'Yahoo דורש סיסמת אפליקציה לחיבור IMAP מצד שלישי.',
        yahooStep1: 'היכנס להגדרות אבטחה של Yahoo והפעל אימות דו-שלבי',
        yahooStep2: 'צור App Password עבור אפליקציית דואר',
        yahooStep3: 'הדבק את הסיסמה כאן והתחבר',
        workspaceInfo: 'עבור Google Workspace (דומיין עסקי) או חשבון IMAP אחר:',
        workspaceStep1: '1. ודא ש-IMAP מופעל בהגדרות החשבון',
        workspaceStep2: '2. אם יש אימות דו-שלבי, צור App Password',
        workspaceStep3: '3. הזן את כתובת המייל המלאה וסיסמת האפליקציה',
        demoMode: 'מצב דמו',
        demoHint: 'תיבת הדמו נטענת מיד — בלי App Password ובלי הגדרות ספק.',
        autoFill: 'מלא אוטומטית',
        sendFrom: 'שליחה מ',
        sendAs: 'שליחה בשם',
        aiComposeDesc: 'תאר מה אתה רוצה לכתוב, וה-AI יכין לך מייל מוכן לשליחה עם שורת נושא.',
        aiComposePlaceholder: 'תאר את המייל שאתה רוצה לשלוח...',
        aiComposing: 'מנסח...',
        aiComposeBtn: 'נסח מייל',
        aiGenerating: 'AI יוצר תגובה...',
        aiGenerateReply: 'צור תגובה עם AI',
        chooseTone: 'בחר סגנון תגובה',
        aiExample1: 'נסח לי הסכם עבודה עם יוסי העובד החדש שלנו',
        aiExample2: 'כתוב מייל סיכום פגישה בהתאם לנקודות הבאות:',
        aiExample3: 'תמצת לי את המאמר הבא לשליחה בניוזלטר:',
        aiExample4: 'כתוב מייל מקצועי לשיתוף פעולה עסקי',
        aiExample5: 'נסח הצעת מחיר ללקוח שביקש שירותי ייעוץ',
        aiExample6: 'כתוב תשובה אדיבה לתלונת לקוח',
        aiExample7: 'נסח הזמנה לכנס / אירוע חברה',
        aiExample8: 'כתוב מייל מעקב אחרי פגישה עסקית',
        trackingStats: 'סטטיסטיקות מעקב',
        trackingStatsTitle: 'סטטיסטיקות מעקב מיילים',
        noTrackingData: 'אין נתוני מעקב עדיין. שלח מייל עם "מעקב פתיחה" מופעל כדי לראות סטטיסטיקות.',
        sentOn: 'נשלח',
        openedOn: 'נפתח',
        openedTimes: 'נפתח {count} פעמים',
        pgpTooltip: 'הצפנת PGP - המייל יוצפן עם מפתח ציבורי של הנמען',
        createFolder: 'צור תיקייה',
        deleteFolderWarning: 'פעולה זו תמחק את התיקייה',
        deleteFolderConfirm: 'האם אתה בטוח שברצונך למחוק את התיקייה? לא ניתן לשחזר פעולה זו.',
        confirmDeleteFolder: 'כן, מחק תיקייה',
        deleteMailAccount: 'מחיקת חשבון דואר',
        confirmDeleteAccount: 'האם אתה בטוח שברצונך למחוק את החשבון',
        deleteAccountWarning: 'פעולה זו תסיר את החשבון מכל המכשירים שלך. תוכל להוסיף אותו מחדש בכל עת.',
        confirmDelete: 'אישור מחיקה',
        scheduleEmail: 'תזמון שליחת מייל',
        scheduleDateLabel: 'תאריך ושעה לשליחה',
        scheduling: 'מתזמן...',
        scheduleSend: 'תזמן שליחה',
        undoSendMsg: 'המייל יישלח בעוד 5 שניות...',
        undoSend: 'בטל שליחה',
        allSearchSelected: 'כל {count} ההודעות התואמות לחיפוש "{query}" נבחרו.',
        cancelSelectAll: 'בטל בחירת הכל',
        allPageSelected: 'כל {count} ההודעות בדף זה נבחרו.',
        selectAllSearchResults: 'בחר את כל {count} ההודעות התואמות לחיפוש',
        onboardingTitle: 'ברוכים הבאים ל-Email Lion!',
        onboardingStep1: 'ברוכים הבאים',
        onboardingStep2: 'תיקיות',
        onboardingStep3: 'כתיבה',
        onboardingStep4: 'טיפים',
        onboarding1Title: 'מערכת הדואר שלך מוכנה!',
        onboarding1Desc: 'Email Lion היא מערכת דואר אלקטרוני מתקדמת עם כלים מקצועיים לניהול המיילים שלך. בואו נכיר את היכולות העיקריות.',
        onboarding2Title: 'תיקיות וארגון',
        onboarding2Desc: 'בצד ימין תמצא את תיקיות הדואר שלך. תוכל ליצור תיקיות חדשות, לגרור מיילים בין תיקיות, ולסנן מיילים לפי קטגוריות חכמות.',
        onboarding3Title: 'כתיבת מייל',
        onboarding3Desc: 'לחץ על "כתיבה" או על מקש C במקלדת. תוכל לצרף קבצים, לתזמן שליחה, להשתמש בתבניות, ולעקוב אחרי פתיחת המייל.',
        onboarding4Title: 'טיפים מקצועיים',
        onboarding4Desc: '• לחץ ? לצפייה בקיצורי מקלדת\n• לחץ / כדי להתמקד בחיפוש\n• השתמש בפילטרים המהירים לסינון מיילים\n• הגדר חתימה אישית בהגדרות\n• הפעל מצב כהה בתפריט העליון',
        skip: 'דלג',
        letsStart: 'בואו נתחיל!',
        keyboardShortcuts: 'קיצורי מקלדת',
        kbCompose: 'כתיבת מייל חדש',
        kbReply: 'השב למייל',
        kbForward: 'העבר מייל',
        kbDelete: 'מחק נבחרים',
        kbEscape: 'סגור / בטל בחירה',
        kbSelectAll: 'בחר הכל',
        kbSearch: 'מיקוד לחיפוש',
        kbHelp: 'עזרה - קיצורים',
        dragToReorder: 'גרור לשינוי סדר',
        defaultAccount: 'ברירת מחדל',
        dragReorderHint: 'גרור לשינוי סדר • ראשון = ברירת מחדל',
        cannotConnectMailServer: 'לא ניתן להתחבר לשרת הדואר. בדוק שכתובת האימייל נכונה.',
        cannotTestConnection: 'לא ניתן לבדוק את החיבור.',
        connectionSaveFailed: 'החיבור נבדק, אבל שמירת התיבה נכשלה. נסה שוב.',
        testingConnection: 'בודק חיבור...',
        loadingOriginalAttachments: 'טוען {count} קבצים מהמייל המקורי...',
        onDatePrefix: 'ב-',
    },

    // ==================== SETTINGS ====================
    settings: {
        title: 'הגדרות',
        tabGeneral: 'כללי',
        tabAi: 'סוכן AI',
        tabSecurity: 'אבטחה',
        tabContacts: 'אנשי קשר',
        tabSignatures: 'חתימות',
        tabTemplates: 'תבניות',
        tabRules: 'כללים',
        tabLabels: 'תוויות',
        tabAlias: 'Alias',
        tabVacation: 'מענה אוטומטי',
        tabSendPermissions: 'הרשאות שליחה',
        tabReferral: 'הפניות',
        viewMode: 'תצוגת הודעות',
        language: 'שפה',
        theme: 'ערכת נושא',
        notifications: 'התראות',
        changePassword: 'שינוי סיסמה',
        currentPassword: 'סיסמה נוכחית',
        newPassword: 'סיסמה חדשה',
        confirmPassword: 'אימות סיסמה',
        passwordChanged: 'סיסמה שונתה בהצלחה',
        twoFactor: 'אימות דו-שלבי (2FA)',
        enable2FA: 'הפעל 2FA',
        disable2FA: 'כבה 2FA',
        pgpEncryption: 'הצפנת PGP',
        addContact: 'הוסף איש קשר',
        editContact: 'ערוך איש קשר',
        deleteContact: 'מחק איש קשר',
        contactName: 'שם',
        contactEmail: 'אימייל',
        contactPhone: 'טלפון',
        contactCompany: 'חברה',
        noContacts: 'אין אנשי קשר',
        addSignature: 'הוסף חתימה',
        editSignature: 'ערוך חתימה',
        deleteSignature: 'מחק חתימה',
        defaultSignature: 'חתימת ברירת מחדל',
        signatureName: 'שם החתימה',
        signatureContent: 'תוכן החתימה',
        noSignatures: 'אין חתימות',
        addTemplate: 'הוסף תבנית',
        editTemplate: 'ערוך תבנית',
        deleteTemplate: 'מחק תבנית',
        templateName: 'שם התבנית',
        templateSubject: 'נושא',
        templateBody: 'תוכן',
        noTemplates: 'אין תבניות',
        addRule: 'הוסף כלל',
        editRule: 'ערוך כלל',
        deleteRule: 'מחק כלל',
        noRules: 'אין כללים',
        ruleName: 'שם הכלל',
        ruleCondition: 'תנאי',
        ruleAction: 'פעולה',
        addLabel: 'הוסף תווית',
        editLabel: 'ערוך תווית',
        deleteLabel: 'מחק תווית',
        noLabels: 'אין תוויות',
        labelName: 'שם התווית',
        labelColor: 'צבע',
        vacationReply: 'מענה אוטומטי (חופשה)',
        vacationEnabled: 'מופעל',
        vacationSubject: 'נושא המענה',
        vacationMessage: 'תוכן המענה',
        vacationStart: 'תאריך התחלה',
        vacationEnd: 'תאריך סיום',
        saved: 'נשמר בהצלחה',
        errorSaving: 'שגיאה בשמירה',
        referralTitle: 'תוכנית הפניות',
        referralCode: 'קוד ההפניה שלך',
        referralLink: 'קישור הפניה',
        copyLink: 'העתק קישור',
        linkCopied: 'קישור הועתק!',
        tabAdvanced: 'מתקדם',
        referralInvitePrefix: 'הזמינו חברים ל-Email Lion וקבלו ',
        referralFreeMonth: 'חודש חינם',
        referralInviteSuffix: ' על כל חבר שמשלם!',
        referralYourCode: 'קוד ההפניה שלכם',
        copied: 'הועתק!',
        copyCode: 'העתק קוד',
        referralsCount: 'הפניות',
        rewardsCount: 'תגמולים',
        aiConfigSaved: 'הגדרות AI נשמרו בהצלחה',
        aiConfigError: 'שגיאה בשמירת הגדרות AI',
        viewSaved: 'תצוגה נשמרה',
        newSignature: 'חתימה חדשה',
        signatureSaved: 'חתימה נשמרה',
        signatureSaveError: 'שגיאה בשמירת חתימה',
        signatureDeleted: 'חתימה נמחקה',
        signatureDeleteError: 'שגיאה במחיקת חתימה',
        categoryGeneral: 'כללי',
        templateNameRequired: 'שם תבנית נדרש',
        templateSaved: 'תבנית נשמרה',
        templateSaveError: 'שגיאה בשמירת תבנית',
        templateDeleted: 'תבנית נמחקה',
        templateDeleteError: 'שגיאה במחיקת תבנית',
        emailRequired: 'אימייל נדרש',
        contactSaved: 'איש קשר נשמר',
        contactSaveError: 'שגיאה בשמירת איש קשר',
        contactDeleteError: 'שגיאה במחיקת איש קשר',
        passwordsMismatch: 'הסיסמאות לא תואמות',
        passwordMinLength: 'סיסמה חייבת להכיל לפחות 6 תווים',
        passwordChangeError: 'שגיאה בשינוי סיסמה',
        twoFASetupError: 'שגיאה בהגדרת 2FA',
        twoFAEnabled: 'אימות דו-שלבי הופעל בהצלחה!',
        twoFAVerifyError: 'קוד אימות שגוי',
        twoFADisabled: 'אימות דו-שלבי בוטל',
        twoFADisableError: 'שגיאה בביטול 2FA',
        pgpRequiredFields: 'נדרש שם, אימייל וסיסמת הצפנה',
        pgpKeyCreated: 'מפתח PGP נוצר בהצלחה',
        pgpKeyCreateError: 'שגיאה ביצירת מפתח',
        pgpPublicKeyImported: 'מפתח ציבורי יובא',
        pgpImportError: 'שגיאה בייבוא מפתח',
        pgpDeleteConfirm: 'למחוק את המפתח?',
        pgpKeyDeleted: 'מפתח נמחק',
        deleteError: 'שגיאה במחיקה',
        delegationAdded: 'הרשאת שליחה נוספה',
        delegationAddError: 'שגיאה בהוספת הרשאה',
        delegationRemoved: 'הרשאה הוסרה',
        delegationRemoveError: 'שגיאה בהסרת הרשאה',
        defaultVacationSubject: 'אני לא זמין כרגע',
        vacationActivated: 'מענה אוטומטי הופעל',
        vacationDeactivated: 'מענה אוטומטי כובה',
        vacationSaveError: 'שגיאה בשמירת מענה אוטומטי',
        ruleNameRequired: 'שם כלל נדרש',
        ruleSaved: 'כלל נשמר',
        ruleSaveError: 'שגיאה בשמירת כלל',
        ruleDeleted: 'כלל נמחק',
        ruleDeleteError: 'שגיאה במחיקת כלל',
        labelSaved: 'תווית נשמרה',
        labelSaveError: 'שגיאה בשמירת תווית',
        labelDeleted: 'תווית נמחקה',
        labelDeleteError: 'שגיאה במחיקת תווית',
        scheduledCancelled: 'שליחה מתוזמנת בוטלה',
        cancelError: 'שגיאה בביטול',
        sessionTerminated: 'סשן נותק',
        sessionTerminateError: 'שגיאה בניתוק',
        allSessionsTerminated: 'כל הסשנים האחרים נותקו',
        aliasEmailRequired: 'כתובת Alias חובה',
        aliasUpdated: 'Alias עודכן',
        aliasAdded: 'Alias נוסף',
        aliasDeleteConfirm: 'למחוק Alias זה?',
        aliasDeleted: 'Alias נמחק',
        mailboxShared: 'תיבה שותפה בהצלחה',
        revokeShareConfirm: 'בטל שיתוף?',
        selectMailboxError: 'יש לבחור תיבת דואר מהרשימה. אם אין תיבות - התחבר קודם דרך עמוד תיבת הדואר.',
        autoReplyAIEnabled: 'מענה אוטומטי AI הופעל!',
        autoReplyConfigSaved: 'הגדרות מענה אוטומטי נשמרו',
        docUploadedSuccess: 'הועלה בהצלחה',
        uploadError: 'שגיאה בהעלאה',
        deleteDocConfirm: 'למחוק מסמך זה ממאגר הידע?',
        docDeleted: 'מסמך נמחק',
        contactExcluded: 'איש קשר הוחרג',
        exclusionRemoved: 'החרגה הוסרה',
        contactsImported: 'אנשי קשר יובאו',
        contactsImportError: 'שגיאה בייבוא אנשי קשר',
        contactsImportedVcard: 'אנשי קשר יובאו מ-vCard',
        vcardImportError: 'שגיאה בייבוא vCard',
        backupStarted: 'הורדת הגיבוי החלה...',
        backupCodesCopied: 'קודי גיבוי הועתקו',
        secretCopied: 'הסוד הועתק',
        aiEngineTitle: 'מנוע AI',
        aiEngineDesc: 'בחר את מנוע ה-AI המועדף עליך לניסוח, תגובות ומענה אוטומטי.',
        defaultModelRecommended: 'מודל ברירת מחדל (מומלץ)',
        saveAiPreferences: 'שמור העדפות AI',
        globalPromptTitle: 'פרומפט מערכת (גלובלי)',
        globalPromptDesc: 'הגדרת פרומפט כללי שישמש את כל פעולות ה-AI: ניסוח מיילים, תגובות, ומענה אוטומטי. תאר את העסק שלך, טון דיבור, הנחיות מיוחדות.',
        globalPromptPlaceholder: 'לדוגמה: אני יועץ עסקי, הטון שלי מקצועי אך חם. תמיד לפנות בשם פרטי. לסיים עם \'בברכה, [שמי]\'. לא להבטיח דברים שלא ניתן לקיים.',
        composePromptTitle: 'פרומפט ייעודי לניסוח מיילים חדשים',
        composePromptPlaceholder: 'הנחיות נוספות ספציפיות לניסוח מיילים חדשים (ריק = ישתמש בפרומפט הגלובלי)',
        replyPromptTitle: 'פרומפט ייעודי לתגובות AI',
        replyPromptPlaceholder: 'הנחיות נוספות ספציפיות ליצירת תגובות למיילים (ריק = ישתמש בפרומפט הגלובלי)',
        autoReplyPromptTitle: 'פרומפט ייעודי למענה אוטומטי',
        autoReplyPromptPlaceholder: 'הנחיות נוספות למענה האוטומטי (ריק = ישתמש בפרומפט הגלובלי)',
        savePromptSettings: 'שמור הגדרות פרומפט',
        aiUsageAndBilling: 'שימוש ב-AI וחיוב',
        runsPerMonth: 'ריצות בחודש',
        autoTopup: 'טעינה אוטומטית (Top-Up) כשנגמרות הריצות',
        runsToAdd: 'כמות ריצות להוספה:',
        runs: 'ריצות',
        recentUsage: 'שימוש אחרון (30 יום):',
        dateColumn: 'תאריך',
        actionColumn: 'פעולה',
        providerColumn: 'ספק',
        quantityColumn: 'כמות',
        featureCompose: 'ניסוח',
        featureReply: 'תגובה',
        featureAutoReply: 'מענה אוטומטי',
        storageQuotaTitle: 'נפח אחסון',
        inUse: 'בשימוש',
        allowed: 'מותר',
        storageUsedPercent: 'מהנפח בשימוש',
        accountsCount: 'חשבונות',
        contactsCountLabel: 'אנשי קשר',
        templatesCountLabel: 'תבניות',
        signaturesCountLabel: 'חתימות',
        emailSignatures: 'חתימות דואר',
        noSignaturesDesc: 'אין חתימות. צור חתימה שתתווסף אוטומטית להודעות שלך.',
        defaultLabel: 'ברירת מחדל',
        mailHandlerTitle: 'יישום מייל ברירת מחדל',
        mailHandlerDesc: 'הגדר את Email Lion כיישום ברירת המחדל לקישורי mailto: בכל המכשיר. לחיצה על מייל באתר, חתימה או הודעה תפתח חלון שליחה כאן.',
        mailHandlerButton: 'קבע כברירת מחדל',
        mailHandlerInstalled: 'נרשם בדפדפן ✓',
        mailHandlerSuccess: 'הבקשה נשלחה לדפדפן. אשר את ההודעה שמופיעה לעיל כדי להפעיל.',
        mailHandlerError: 'הדפדפן דחה את הבקשה. ייתכן שהיא כבר אושרה או שהפעולה דורשת HTTPS.',
        mailHandlerNotSupported: 'הדפדפן הזה לא חושף את ה-API לרישום אוטומטי של פרוטוקול mailto:. אם האפליקציה כבר מותקנת — מערכת ההפעלה אמורה להציע אותה אוטומטית. אחרת, פתח באפליקציית הדפדפן (Chrome / Edge / Firefox).',
        mailHandlerHttpsRequired: 'רישום ה-handler דורש חיבור מאובטח (HTTPS). פתח את הדף ב-https://emaillion.net.',
        mailHandlerStandaloneTitle: 'האפליקציה מותקנת ופועלת ✓',
        mailHandlerStandaloneDesc: 'מאחר שהאפליקציה מותקנת, מערכת ההפעלה אחראית לנתב קישורי mailto:. כדי לקבוע אותה כברירת מחדל: לחץ על כפתור הבדיקה למטה, או על קישור mailto: כלשהו מחוץ לאפליקציה — מערכת ההפעלה תציג רשימת אפליקציות, בחר Email Lion וסמן "תמיד".',
        mailHandlerTestTitle: '🔗 בדיקה',
        mailHandlerTestDesc: 'לחיצה על הכפתור פותחת קישור mailto: בדיקה. אם ההגדרות תקינות — חלון שליחה יפתח כאן ב-Email Lion. אחרת מערכת ההפעלה תציג רשימת אפליקציות אפשריות.',
        mailHandlerTestButton: 'פתח קישור mailto: לבדיקה',
        mailHandlerAndroidHint: 'אנדרואיד: לאחר התקנת ה-PWA, לחץ על קישור mailto: בכל אפליקציה (דפדפן, WhatsApp, וכו\'). אנדרואיד תציג "פתח באמצעות" — בחר Email Lion וסמן "תמיד". כדי לשנות מאוחר יותר: הגדרות מערכת ➤ אפליקציות ➤ אפליקציות ברירת מחדל ➤ אפליקציית דואר.',
        mailHandlerIosHint: 'iOS: Apple לא מאפשר להחליף את אפליקציית המייל ברירת המחדל ב-PWA. מומלץ להשתמש ב-Email Lion דרך הדפדפן או דרך הוספה למסך הבית.',
        mailHandlerDesktopHint: 'מחשב: לחיצה על "קבע כברירת מחדל" תרשום את Email Lion בדפדפן. כדי להגדיר אותה כברירת מחדל ברמת מערכת ההפעלה (Windows): הגדרות ➤ Apps ➤ Default apps ➤ Mail.',
        emailTemplates: 'תבניות מייל',
        newTemplate: 'תבנית חדשה',
        noTemplatesDesc: 'אין תבניות. צור תבניות לתשובות מהירות.',
        subjectPrefix: 'נושא:',
        noSubject: 'ללא נושא',
        exportCsv: 'ייצוא CSV',
        importCsv: 'ייבוא CSV',
        exportVcard: 'ייצוא vCard (.vcf) - תואם Google / Apple / Outlook',
        importVcard: 'ייבוא vCard (.vcf) - מ-Google / Apple / Outlook',
        searchPlaceholder: 'חיפוש...',
        addButton: 'הוסף',
        contactsSavedAuto: 'אנשי קשר נשמרים אוטומטית כששולחים מיילים. תוכל גם להוסיף ידנית.',
        importExportContacts: 'ייבוא/ייצוא אנשי קשר',
        csvDescription: 'ייצוא וייבוא בפורמט טבלאי (אקסל, Google Sheets)',
        vcardDescription: 'הפורמט הסטנדרטי לאנשי קשר. תואם Google Contacts, Apple, Outlook',
        gmailMigrationHint: 'עובר מ-Gmail? היכנס ל-',
        gmailMigrationHint2: ' > ייצוא > בחר vCard > ייבא את הקובץ כאן',
        vacationActiveAlert: 'מענה אוטומטי פעיל - כל מי שישלח לך מייל יקבל תגובה אוטומטית.',
        messageSubject: 'נושא ההודעה',
        vacationPlaceholder: 'שלום, אני לא זמין כרגע. אחזור אליך בהקדם...',
        fromDate: 'מתאריך',
        toDate: 'עד תאריך',
        sendToContactsOnly: 'שלח רק לאנשי קשר שלי',
        saveAndActivate: 'שמור והפעל',
        saveDisabled: 'שמור (כבוי)',
        rulesAndFilters: 'כללים וסינונים',
        rulesDescription: 'כללים מאפשרים למיין, לסמן או למחוק מיילים אוטומטית לפי תנאים שתגדיר.',
        newRule: 'כלל חדש',
        noRulesDesc: 'אין כללים. צור כלל חדש כדי למיין מיילים אוטומטית.',
        ruleDisabled: 'כבוי',
        contactsManagement: 'ניהול אנשי קשר',
        contactsManagementDesc: 'ניהול, ייבוא וייצוא אנשי קשר. בחר בטאב "כללי" לעריכה מלאה.',
        goToGeneralSettings: 'עבור להגדרות כלליות לניהול אנשי קשר',
        minChars: 'מינימום 6 תווים',
        confirmNewPassword: 'אישור סיסמה חדשה',
        changePasswordBtn: 'שנה סיסמה',
        twoFactorDesc: 'הוסף שכבת אבטחה נוספת לחשבון שלך באמצעות אפליקציית אימות כמו Google Authenticator.',
        twoFactorActive: 'אימות דו-שלבי מופעל ופעיל',
        backupCodesTitle: 'קודי גיבוי (שמור אותם במקום בטוח!):',
        copyAll: 'העתק הכל',
        disablePassword: 'סיסמה לביטול',
        disable2FABtn: 'ביטול 2FA',
        scanQrCode: 'סרוק את הקוד באפליקציית האימות, או הזן את הסוד ידנית.',
        scanWithAuthenticator: 'סרוק עם Google Authenticator',
        secretManualEntry: 'סוד (להזנה ידנית)',
        enterCodeFromApp: 'הזן את הקוד מהאפליקציה',
        verifyAndEnable: 'אמת והפעל',
        enableTwoFactor: 'הפעל אימות דו-שלבי',
        delegationTitle: 'האצלת שליחה (Delegation)',
        delegationDesc: 'אפשר למשתמשים אחרים לשלוח מיילים בשמך. הם יוכלו לבחור את הכתובת שלך כשולח בעת כתיבת מייל.',
        delegateEmailLabel: 'אימייל המשתמש',
        sendAs: 'שליחה בשם',
        sendOnBehalf: 'שליחה מטעם',
        noDelegations: 'אין הרשאות שליחה פעילות',
        pgpTitle: 'הצפנת מיילים (PGP)',
        pgpDesc: 'נהל מפתחות PGP להצפנה וחתימה דיגיטלית של מיילים. צור מפתחות חדשים או ייבא מפתחות ציבוריים של אנשי קשר.',
        createNewKey: 'צור מפתח חדש',
        pgpPassphrase: 'סיסמת הצפנה (Passphrase)',
        pgpPassphraseHelper: 'זכור סיסמה זו - תצטרך אותה לחתימה ופענוח',
        createKey: 'צור מפתח',
        importPublicKey: 'ייבוא מפתח ציבורי:',
        importKey: 'ייבא מפתח',
        privateAndPublic: 'פרטי+ציבורי',
        publicKey: 'ציבורי',
        fingerprint: 'טביעת אצבע',
        noPgpKeys: 'אין מפתחות PGP מוגדרים',
        labelsTitle: 'תוויות',
        addLabelBtn: 'הוסף תווית',
        noLabelsAlert: 'טרם נוצרו תוויות. תוויות מאפשרות לסווג מיילים בצבעים.',
        editLabelTitle: 'עריכת תווית',
        newLabelTitle: 'תווית חדשה',
        labelNameField: 'שם תווית',
        colorLabel: 'צבע:',
        preview: 'תצוגה מקדימה',
        scheduledEmails: 'מיילים מתוזמנים',
        refreshBtn: 'רענן',
        noScheduledEmails: 'אין מיילים מתוזמנים. ניתן לתזמן שליחת מייל מחלון ההודעה החדשה.',
        recipient: 'נמען',
        scheduledFor: 'מתוזמן ל-',
        statusPending: 'ממתין',
        statusSent: 'נשלח',
        statusCancelled: 'בוטל',
        statusFailed: 'נכשל',
        cancelSend: 'בטל שליחה',
        noSubjectLabel: '(ללא נושא)',
        aiAutoReplyTitle: 'מענה אוטומטי חכם AI',
        active: 'פעיל',
        inactive: 'כבוי',
        selectMailbox: 'בחר תיבת דואר להפעלת מענה אוטומטי:',
        noMailboxes: 'אין תיבות דואר מחוברות. יש להתחבר לתיבת דואר דרך עמוד תיבת הדואר לפני שניתן להפעיל מענה אוטומטי.',
        betaInfo: 'המענה האוטומטי יענה על מיילים נכנסים בהתבסס על הפרומפט ומאגר הידע שלך. רק מיילים אמיתיים - לא ספאם, פרסומות, או ניוזלטרים.',
        activeMailbox: 'תיבה פעילה:',
        promptSetup: 'הגדרת פרומפט ואיפיון',
        promptSetupDesc: 'הגדר כאן מי אתה, מה העסק שלך, ואיך לענות. ככל שההנחיות מפורטות יותר, התגובות יהיו טובות יותר.',
        toneLabel: 'טון',
        toneProfessional: 'מקצועי',
        toneFriendly: 'ידידותי',
        toneBrief: 'קצר',
        toneFormal: 'רשמי',
        languageLabel: 'שפה',
        hebrew: 'עברית',
        maxLengthWords: 'אורך מקסימלי (מילים)',
        delayMinutes: 'השהיה (דקות)',
        knowledgeBase: 'מאגר ידע',
        documentsCount: 'מסמכים',
        knowledgeBaseDesc: 'העלה מסמכים שה-AI ישתמש בהם כדי לענות בצורה מדויקת. פורמטים נתמכים: TXT, CSV, JSON, HTML, MD.',
        uploadDocument: 'העלה מסמך',
        maxDocSize: 'מקסימום 50KB לכל מסמך',
        noDocuments: 'אין מסמכים. העלה מסמכים כדי שה-AI יוכל לענות בצורה מדויקת יותר.',
        emailFiltering: 'סינון מיילים',
        skipSpam: 'דלג על ספאם',
        skipPromotions: 'דלג על פרסומות',
        skipNewsletters: 'דלג על ניוזלטרים',
        skipNoreply: 'דלג על כתובות no-reply',
        skipAutoReplies: 'דלג על מענים אוטומטיים',
        onlyKnownContacts: 'ענה רק לאנשי קשר מוכרים',
        startHour: 'שעת התחלה',
        endHour: 'שעת סיום',
        activeDays: 'ימים פעילים',
        maxRepliesPerDay: 'מקסימום תגובות ביום',
        maxRepliesPerSender: 'מקסימום לשולח',
        exclusionsTitle: 'החרגות',
        exclusionsDesc: 'אנשי קשר שלא יקבלו מענה אוטומטי - תענה להם ידנית.',
        exclusionName: 'שם (אופציונלי)',
        exclusionReason: 'סיבה',
        replyLog: 'יומן מענים',
        sentCount: 'נשלחו',
        skippedCount: 'דולגו',
        failedCount: 'נכשלו',
        excludedCount: 'הוחרגו',
        avgTime: 'זמן ממוצע',
        noLogEntries: 'אין רשומות עדיין.',
        senderColumn: 'שולח',
        reasonResponseColumn: 'סיבה / תגובה',
        logStatusSent: 'נשלח',
        logStatusSkipped: 'דולג',
        logStatusExcluded: 'הוחרג',
        logStatusFailed: 'נכשל',
        saving: 'שומר...',
        saveAutoReplySettings: 'שמור הגדרות מענה אוטומטי',
        backupExport: 'גיבוי וייצוא תיבת דואר',
        backupDesc: 'הורד את כל המיילים מהתיקייה הנבחרת כקובץ ZIP. כל מייל נשמר בפורמט .eml.',
        inboxFolder: 'דואר נכנס',
        sentFolder: 'דואר נשלח',
        draftsFolder: 'טיוטות',
        trashFolder: 'אשפה',
        spamFolder: 'ספאם',
        downloadBackup: 'הורד גיבוי (ZIP)',
        aliasAddresses: 'כתובות Alias',
        addAlias: 'הוסף Alias',
        noAliases: 'לא הוגדרו כתובות Alias. הוסף כתובות כדי לשלוח מהן מיילים.',
        noDisplayName: 'ללא שם תצוגה',
        sharedMailboxes: 'תיבות דואר משותפות',
        shareMailbox: 'שתף תיבה',
        sharedWithMe: 'תיבות ששותפו איתי:',
        myShares: 'תיבות ששיתפתי:',
        permissionRead: 'קריאה',
        permissionWrite: 'כתיבה',
        permissionAdmin: 'מנהל',
        sharedWith: 'שותפה עם:',
        permissionLabel: 'הרשאה:',
        noSharedMailboxes: 'אין תיבות משותפות. לחץ "שתף תיבה" כדי לשתף עם חברי צוות.',
        shareMailboxDialog: 'שתף תיבת דואר',
        shareMailboxDesc: 'בחר את תיבת הדואר שברצונך לשתף ואת המשתמש שתרצה לשתף איתו.',
        mailboxToShare: 'תיבת דואר לשיתוף',
        noConnectedMailboxes: 'אין תיבות מחוברות',
        shareWithUser: 'שתף עם משתמש',
        searchUserPlaceholder: 'חפש משתמש לפי שם או מייל...',
        noUsersFound: 'לא נמצאו משתמשים',
        loadingUsers: 'טוען משתמשים...',
        noName: 'ללא שם',
        adminRole: 'מנהל',
        userRole: 'משתמש',
        permissionLevel: 'רמת הרשאה',
        readOnlyDesc: 'קריאה בלבד - צפייה בהודעות',
        readWriteDesc: 'קריאה + כתיבה - שליחת הודעות',
        fullAdminDesc: 'מנהל מלא - כולל הגדרות',
        shareBtn: 'שתף',
        activeSessions: 'סשנים פעילים',
        disconnectAll: 'נתק הכל',
        noSessions: 'אין סשנים פעילים ברישום.',
        deviceBrowser: 'מכשיר / דפדפן',
        ipAddress: 'כתובת IP',
        lastActivity: 'פעילות אחרונה',
        createdColumn: 'נוצר',
        unknown: 'לא ידוע',
        disconnectSession: 'נתק סשן',
        editAliasTitle: 'עריכת Alias',
        newAliasTitle: 'הוספת Alias חדש',
        aliasEmailField: 'כתובת אימייל',
        displayNameField: 'שם תצוגה',
        displayNamePlaceholder: 'שם שיוצג לנמענים',
        setAsDefault: 'הגדר ככתובת ברירת מחדל',
        ruleIfPrefix: 'אם',
        conditionFrom: 'מאת',
        conditionTo: 'אל',
        conditionSubject: 'נושא',
        conditionHasAttachment: 'יש קובץ מצורף',
        conditionContains: 'מכיל',
        conditionEquals: 'שווה ל',
        conditionStartsWith: 'מתחיל ב',
        conditionEndsWith: 'מסתיים ב',
        conditionYes: 'כן',
        actionMoveToFolder: 'העבר לתיקייה',
        actionMarkRead: 'סמן כנקרא',
        actionStar: 'סמן בכוכב',
        actionDelete: 'מחק',
        actionForward: 'העבר לכתובת',
        valuePlaceholder: 'ערך...',
        folderNamePlaceholder: 'שם תיקייה (כגון: Spam, Archive)',
        forwardPlaceholder: 'כתובת להעברה',
        ruleActive: 'כלל פעיל',
        conditionLabel: 'תנאי',
        actionLabel: 'פעולה',
        sigDialogPlaceholder: 'כתוב את החתימה שלך כאן...',
        templateContentPlaceholder: 'כתוב את תוכן התבנית...',
        category: 'קטגוריה',
        subjectOptional: 'נושא (אופציונלי)',
        notesLabel: 'הערות',
        newContactTitle: 'איש קשר חדש',
        popupView: 'חלון צף (Popup)',
        popupViewDesc: 'לחיצה על מייל פותחת חלון דיאלוג.',
        pageView: 'עמוד נפרד (Gmail)',
        pageViewDesc: 'לחיצה על מייל פותחת בעמוד שלם.',
        previewView: 'תצוגה מקדימה (Outlook)',
        previewViewDesc: 'לחיצה מציגה תצוגה מקדימה בצד.',
        recommended: 'מומלץ',
        fast: 'מהיר',
        dayNamesShort: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
        betaModePrefix: 'מצב BETA:',
        webmailPage: 'תיבת הדואר',
        promptExample: 'דוגמה:\nאני יוסי, מנהל חברת אמיליון. אנחנו חברת פיתוח ועיצוב אתרים.\n\nמחירון:\n- אתר תדמיתי: 3,000-8,000 ש"ח\n- חנות אונליין: 8,000-15,000 ש"ח\n- אפליקציה: מ-20,000 ש"ח\n\nאנא ענה על שאלות לקוחות בצורה מקצועית ונעימה.',
        dangerZone: 'אזור מסוכן',
        deleteAccountTitle: 'מחיקת חשבון',
        deleteAccountDesc: 'מחיקת החשבון היא בלתי הפיכה. כל הנתונים שלך יסומנו כנמחקים ותצא מהמערכת.',
        deleteAccountBtn: 'מחק חשבון',
        deleteIrreversible: 'פעולה זו בלתי הפיכה לחלוטין. חשבונך יסומן כנמחק ולא תוכל להתחבר שוב.',
        deleteConfirmQuestion: 'האם אתה בטוח שברצונך למחוק את החשבון?',
        deleteAfterInfo: 'לאחר המחיקה תצא מהמערכת אוטומטית. מנהל המערכת יקבל הודעה על כך.',
        deleteTypeToConfirm: 'כדי לאשר, הקלד בשדה הבא:',
        deleteTypeLabel: 'הקלד לאישור',
        deleteContinue: 'המשך',
        deleteInProgress: 'מוחק...',
        deleteConfirmBtn: 'אשר מחיקה',
        deleteAccountError: 'שגיאה במחיקת החשבון',
        connectionTestSubject: 'בדיקת חיבור Email Lion',
        connectionTestBody: 'אם החלון הזה נפתח אצלך ב-Email Lion — ההגדרה עובדת.',
    },

    // ==================== DASHBOARD PAGE ====================
    dashboard: {
        title: 'לוח בקרה',
        greeting: 'שלום',
        dateLocale: 'he-IL',
        organizations: 'ארגונים',
        activeMailboxes: 'תיבות פעילות',
        domains: 'דומיינים',
        storageUsed: 'נפח בשימוש',
        activityTrend: 'פעילות ב-7 ימים אחרונים',
        activityByType: 'סוגי פעילות (30 יום)',
        storageByOrg: 'נפח אחסון לפי ארגון',
        usersByRole: 'משתמשים לפי תפקיד',
        mailboxStatus: 'סטטוס תיבות דואר',
        recentActivity: 'פעילות אחרונה',
        noData: 'אין נתונים',
        noDataYet: 'אין נתונים עדיין',
        noDataToShow: 'אין נתונים להצגה',
        system: 'מערכת',
        storageUsedLabel: 'בשימוש',
        storageQuotaLabel: 'מכסה',
        connectedAccounts: 'מחוברות',
        hostedMailboxes: 'מתארחות',
        totalMailboxes: 'מתוך {{total}} סה"כ',
        verifiedDomains: 'מאומתים',
        actionsLabel: 'פעולות',
        roles: {
            super_admin: 'מנהל ראשי',
            org_admin: 'מנהל ארגון',
            multi_org_admin: 'מנהל ארגונים',
            user: 'משתמש',
        },
        actions: {
            login: 'כניסה',
            send_email: 'שליחת מייל',
            create_user: 'יצירת משתמש',
            update_user: 'עדכון משתמש',
            delete_user: 'מחיקת משתמש',
            create_org: 'יצירת ארגון',
            create_domain: 'יצירת דומיין',
            create_mailbox: 'יצירת תיבה',
        },
    },

    // ==================== MODULES / TRIAL ====================
    modules: {
        automations: {
            title: 'אוטומציות AI על מיילים',
            tagline: 'נתח מיילים נכנסים, חלץ נתונים מקבצים, צור משימות אוטומטית.',
            bullets: [
                'AI מסכם, מקטלג ושולח מענה לכל מייל רלוונטי',
                'דוח יומי מתוזמן כולל משימות, מיילים והתראות מהיומן',
                'הוצא קבצים מצורפים ושלח ל-Drive/Dropbox עם תיוק חכם',
            ],
            trialDescription: 'במהלך ההתנסות תוכל ליצור אוטומציה אחת ולהריץ אותה עד 10 פעמים.',
            gentleNudge: 'התחל עם אוטומציה אחת לבדיקת מייל אמיתי. אחרי שתראה תוצאה, השדרוג פותח עוד אוטומציות והרצות רציפות.',
            primaryCta: 'שדרג לאוטומציות מלאות',
            secondaryCta: 'חבר תיבה קודם',
        },
        ai_agent: {
            title: 'סוכן AI אישי',
            tagline: 'שיחה חופשית עם AI שמכיר את התיבה, היומן והמשימות שלך.',
            bullets: [
                'שואל בעברית, מקבל פעולות מבוצעות (שלח, סווג, ארכב)',
                'מתחבר ל-Green Invoice, מאתר חשבוניות, מסכם מיילים',
                'שומר זיכרון אישי ותבניות פרומפט שתעצב לעצמך',
            ],
            trialDescription: 'במהלך ההתנסות תקבל 10 שיחות חינם.',
            gentleNudge: 'נסה לשאול על המיילים, היומן או האוטומציות שלך. בזמן ניסיון לא נגבה קרדיטים, ולאחר מכן ממשיכים עם חבילת קרדיטים.',
            primaryCta: 'רכוש קרדיטים',
            secondaryCta: 'חבר תיבה כדי לקבל תשובות טובות יותר',
        },
        filing: {
            title: 'תיוק מסמכים חכם',
            tagline: 'כל מסמך שמגיע במייל מסתדר לבד בתיקייה הנכונה ב-Drive או Dropbox.',
            bullets: [
                'AI מזהה סוג מסמך (חשבונית / חוזה / קבלה) ומתיק אוטומטית',
                'חיבור OAuth מאובטח ל-Google Drive ול-Dropbox',
                'כללי תיוק מותאמים — לפי שולח, מילות מפתח, תוכן',
            ],
            trialDescription: 'במהלך ההתנסות תוכל ליצור כלל אחד ולתייק עד 10 מסמכים.',
            gentleNudge: 'אפשר ליצור חיבור ענן וכלל ראשון לניסיון. אחרי כמה תיוקים מוצלחים, החבילה המלאה פותחת תיוק רציף.',
            primaryCta: 'שדרג לתיוק מלא',
            secondaryCta: 'צור כלל ראשון',
        },
        proposals: {
            title: 'מערכת הצעות מחיר',
            tagline: 'הצעת מחיר בעיצוב מקצועי, אישור אונליין וחתימה דיגיטלית — אפילו לסלולרי.',
            bullets: [
                'יצירה מהירה מתוך תבנית, חישוב אוטומטי של מע״מ והנחות',
                'הלקוח מאשר וחותם אונליין — אין יותר PDF להחזיר במייל',
                'גביית תשלום ראשוני מובנית, כולל קבלה',
            ],
            trialDescription: 'במהלך ההתנסות תוכל ליצור עד 10 הצעות מחיר.',
            gentleNudge: 'צור כמה הצעות אמיתיות וראה איך הלקוח מאשר אונליין. אחרי ההתנסות ממשיכים דרך חבילה או מודול הצעות.',
            primaryCta: 'שדרג להצעות ללא הגבלה',
            secondaryCta: 'צור הצעה לדוגמה',
        },
        trialEnded: 'ההתנסות הסתיימה — שדרג',
        trialMode: 'מצב התנסות',
        trialRemaining: 'ניסיון: {remaining}/{max} נשארו',
        trialAlertText: 'במצב התנסות — נשארו לך {remaining} מתוך {max} שימושים.',
        upgradeBtn: 'שדרג',
        moduleFallback: 'מודול',
        viewOnlyMode: 'מצב צפייה בלבד',
        upgradeNow: 'שדרג עכשיו לגישה מלאה',
        getQuote: 'קבל הצעת מחיר',
        capReachedTitle: 'הגעת לגבול ההתנסות',
        trialEndedTitle: 'ההתנסות הסתיימה',
        trialExhaustedMsg: 'מיצית את כמות ההתנסות במודול הזה. שדרג כדי לקבל גישה מלאה ולפתוח את כל היכולות.',
        trialAutomationCapMsg: 'במצב התנסות ניתן ליצור אוטומציה אחת בלבד. שדרוג פותח אוטומציות ללא הגבלה.',
        trialRuleCapMsg: 'במצב התנסות ניתן ליצור כלל אחד בלבד. שדרוג פותח כללים ללא הגבלה.',
        upgradeNowBtn: 'שדרג עכשיו',
    },

    // ==================== UPGRADE PROMPT ====================
    upgrade: {
        upgradePlan: 'שדרג חבילה',
        choosePlan: 'בחר חבילה',
        perMailbox: '/תיבה',
        mailboxCount: 'מספר תיבות:',
        billingCycle: 'מחזור חיוב',
        monthly: 'חודשי',
        yearly: 'שנתי',
        perMonthShort: '/חו׳',
        yearlySavings: '(חיסכון 20%)',
        platformFee: 'דמי פלטפורמה',
        mailboxes: 'תיבות',
        volumeDiscount: 'הנחת כמות ({percent}%)',
        vat: 'מע״מ (18%)',
        totalYearlyVat: 'סה״כ שנתי כולל מע״מ',
        totalMonthlyVat: 'סה״כ חודשי כולל מע״מ',
        perMonthOnly: '= ₪{amount} לחודש בלבד (כולל מע״מ)',
        payNow: 'שלם עכשיו',
        paymentTitle: 'תשלום',
        preparingPayment: 'מכין דף תשלום...',
        paymentFailed: 'התשלום נכשל. נסה שוב.',
        noPaymentLink: 'לא התקבל קישור לתשלום',
        paymentError: 'שגיאה ביצירת התשלום',
        freePlanBanner: 'אתם על חבילת חינם — שדרגו לחבילה בתשלום וקבלו תיבות, אחסון ומודולים מלאים',
        nearLimitBanner: 'הגעתם ל-{percent}% מהמכסה — שדרגו כדי לא להיחסם',
        upgradeNow: 'שדרג עכשיו',
        getQuote: 'קבל הצעת מחיר',
        getDetailedQuote: 'קבל הצעת מחיר מפורטת',
        upgradeToPaid: 'שדרגו לחבילה בתשלום',
        nearPlanLimit: 'קרוב למגבלת החבילה',
        mailboxesUsage: 'תיבות: {used}/{max} ({percent}%)',
        storageUsage: 'אחסון: {used} GB / {max} GB ({percent}%)',
    },

    // ==================== ATTACHMENTS ====================
    attachments: {
        attachedFiles: 'קבצים מצורפים',
        file: 'קובץ',
        clickToView: 'לחץ לצפייה',
        clickToDownload: 'לחץ להורדה',
        download: 'הורדה',
        downloadError: 'שגיאה בהורדת הקובץ',
        loadError: 'שגיאה בטעינת הקובץ',
        cannotLoadFile: 'לא ניתן לטעון את הקובץ',
        tryDownload: 'נסה להוריד',
        downloadFile: 'הורד את הקובץ',
        downloadFileShort: 'הורד קובץ',
        loadingFile: 'טוען קובץ...',
        loadingEditView: 'טוען תצוגה לעריכה...',
        loading: 'טוען...',
        pdfRenderError: 'לא ניתן לטעון תצוגת PDF. ניתן לצייר על הרקע הלבן - החתימות יישמרו בקובץ.',
        pdfNotSupported: 'הדפדפן אינו תומך בתצוגת PDF מוטבעת',
        ofTotal: 'מתוך',
        finishEditing: 'סיום עריכה',
        editAnnotate: 'ערוך / סמן',
        signature: 'חתימה',
        saveSignedPdf: 'שמור PDF חתום',
        print: 'הדפס',
        replyWithFile: 'השב עם הקובץ',
        drawTool: 'כלי ציור',
        draw: 'ציור',
        addText: 'הוסף טקסט',
        text: 'טקסט',
        handTool: 'כלי יד (גרירת חתימה)',
        move: 'הזז',
        undoLast: 'בטל אחרון',
        clearAll: 'נקה הכל',
        eSignature: 'חתימה אלקטרונית',
        drawSignatureTab: 'צייר חתימה',
        savedSignaturesTab: 'חתימות שמורות',
        uploadImageTab: 'העלה תמונה',
        drawSignatureHint: 'צייר את החתימה שלך בשדה למטה. החתימה תישמר כ-PNG שקוף.',
        clear: 'נקה',
        signatureNamePlaceholder: 'שם החתימה (אופציונלי)',
        saveSignatureTooltip: 'שמור חתימה לשימוש עתידי',
        save: 'שמור',
        noSavedSignatures: 'אין חתימות שמורות',
        drawNewSignature: 'צייר חתימה חדשה',
        signatureDefault: 'חתימה',
        setAsDefault: 'הגדר כברירת מחדל',
        deleteSig: 'מחק',
        uploadSignatureImage: 'העלה תמונת חתימה',
        uploadHint: 'מומלץ PNG שקוף. תמונות אחרות (JPG, WEBP) ימורו אוטומטית.',
        chooseImage: 'בחר תמונה',
        imageSavedToAccount: 'התמונה תישמר בחשבונך לשימוש חוזר',
        cancel: 'ביטול',
        placeSignatureOnDoc: 'הנח חתימה על המסמך',
        clickSigToPlace: 'לחץ על חתימה כדי להניח אותה על המסמך',
        drawSignatureFirst: 'אנא צייר חתימה תחילה',
        signatureSaved: 'החתימה נשמרה בהצלחה',
        signatureSaveError: 'שגיאה בשמירת החתימה',
        chooseImageFile: 'יש לבחור קובץ תמונה',
        imageSavedAsSignature: 'התמונה נשמרה כחתימה',
        imageSaveError: 'שגיאה בשמירת התמונה',
        importedSignature: 'חתימה מיובאת',
        signatureDeleted: 'החתימה נמחקה',
        signatureDeleteError: 'שגיאה במחיקת החתימה',
        signedFileSaved: 'הקובץ החתום נשמר בהצלחה',
        signedFileSaveError: 'שגיאה בשמירת PDF מסומן',
        signedFileAttached: 'הקובץ החתום צורף לתשובה',
        fileAttached: 'הקובץ צורף לתשובה',
        attachError: 'שגיאה בצירוף הקובץ',
        noSubject: '(ללא נושא)',
        emailFrom: 'מאת:',
        emailTo: 'אל:',
        emailCc: 'עותק:',
        emailDate: 'תאריך:',
        emptyEmailBody: 'המייל המצורף ריק.',
        nestedAttachments: 'קבצים בתוך המייל',
        csvPreviewHint: 'מציג {shown} מתוך {total} שורות',
        noCalendarEvents: 'לא נמצאו אירועים בקובץ היומן',
        untitledEvent: 'אירוע ללא כותרת',
        eventWhen: 'מתי',
        eventWhere: 'איפה',
        noContacts: 'לא נמצאו אנשי קשר',
        unnamedContact: 'איש קשר ללא שם',
        officeNeedsDownload: 'קבצי Word / Excel / PowerPoint נפתחים אחרי הורדה, כמו ברוב תוכנות המייל.',
        msgNeedsDownload: 'קובץ Outlook (.msg) לא נפתח בדפדפן. הורידו אותו או בקשו מהשולח לשלוח .eml.',
    },

    // ==================== AI AGENT ====================
    aiAgent: {
        title: 'סוכן AI אישי',
        subtitle: 'שאל שאלות ובצע משימות במיילים, יומן, אוטומציות ותיוק. פעולות רגישות ימתינו לאישור.',
        subtitleShort: 'שאל שאלות ובצע משימות במיילים, יומן, אוטומציות ותיוק.',
        conversations: 'שיחות',
        noConversations: 'אין שיחות עדיין',
        newConversation: 'שיחה חדשה',
        deleteConversationAria: 'מחק שיחה',
        deleteConversationConfirm: 'למחוק את השיחה מההיסטוריה?',
        conversationDeleted: 'השיחה נמחקה מההיסטוריה',
        errorLoadConversations: 'שגיאה בטעינת שיחות הסוכן',
        errorLoadConversation: 'שגיאה בטעינת השיחה',
        errorDeleteConversation: 'שגיאה במחיקת השיחה',
        errorSendMessage: 'שגיאה בשליחת הודעה לסוכן',
        errorLoadGreenInvoice: 'שגיאה בטעינת הגדרות חשבונית ירוקה',
        errorLoadMemories: 'שגיאה בטעינת זיכרונות הסוכן',
        errorLoadPending: 'שגיאה בטעינת פעולות ממתינות',
        errorLoadUsage: 'שגיאה בטעינת דוחות שימוש ועלויות',
        errorLoadBilling: 'שגיאה בטעינת הגדרות חיוב',
        greenInvoiceSaved: 'הגדרות חשבונית ירוקה נשמרו בהצלחה',
        errorSaveGreenInvoice: 'שגיאה בשמירת הגדרות חשבונית ירוקה',
        connectionTestFailed: 'בדיקת החיבור נכשלה',
        memorySaved: 'הזיכרון נשמר בהצלחה',
        errorSaveMemory: 'שגיאה בשמירת הזיכרון',
        memoryDeleted: 'הזיכרון נמחק',
        errorDeleteMemory: 'שגיאה במחיקת הזיכרון',
        billingSaved: 'הגדרות החיוב נשמרו',
        errorSaveBilling: 'שגיאה בשמירת הגדרות חיוב',
        errorCreatePayment: 'שגיאה ביצירת תשלום לחבילת קרדיטים',
        paymentsSynced: 'בדקתי תשלומים ועדכנתי את יתרת הקרדיטים אם התשלום הושלם',
        errorSyncPayments: 'שגיאה בסנכרון תשלום הקרדיטים',
        topupEnabled: 'Top-up אוטומטי הופעל. פותח תשלום ראשוני כדי למלא את היתרה עכשיו.',
        errorSaveTopup: 'שגיאה בשמירת הגדרות Top-up',
        templateNeedsNameAndText: 'יש לתת לתבנית שם וטקסט',
        templateUpdated: 'התבנית עודכנה',
        templateSaved: 'התבנית נשמרה',
        errorSaveTemplate: 'שגיאה בשמירת התבנית',
        deleteTemplateConfirm: 'למחוק את התבנית?',
        errorDeleteTemplate: 'שגיאה במחיקת התבנית',
        errorConfirmation: 'שגיאה בטיפול באישור',
        doneFallback: 'בוצע.',
        actionApproved: 'הפעולה אושרה ובוצעה.',
        actionCancelled: 'הפעולה בוטלה ולא בוצעה.',
        templatesBtn: 'תבניות',
        pendingActionsBtn: 'פעולות ממתינות',
        pendingActionsTooltip: 'פעולות ממתינות ({count})',
        settingsBtn: 'הגדרות',
        personalScopeChip: 'scope אישי בלבד',
        approvalChip: 'אישור לפני פעולות כתיבה',
        availableCredits: 'קרדיטים זמינים: {amount}',
        greenInvoiceConnectedChip: 'חשבונית ירוקה מחוברת',
        questionTemplates: 'תבניות שאלות',
        howCanIHelp: 'איך אפשר לעזור?',
        examplesText: 'לדוגמה: "חפש מיילים מהלקוח דני", "נתח לי את היומן השבוע", "סנכרן את היומן מ-Google", "הכן אוטומציה לחשבוניות מספקים" או "ארגן לי קבצים בדרייב".',
        pendingApprovalTitle: 'פעולות ממתינות לאישור',
        pendingApprovalText: 'קיימות {count} פעולות מכל שיחות הסוכן שמחכות לאישור שלך.',
        openApprovalBoard: 'פתח לוח אישורים',
        toolResult: 'תוצאת כלי:',
        purchase: 'רכוש',
        enableTopup: 'הפעל Top-up',
        actionApprovalRequired: 'נדרש אישור פעולה',
        toolLabel: 'כלי:',
        approveAndRun: 'אשר ובצע',
        cancelBtn: 'בטל',
        agentThinking: 'הסוכן חושב...',
        inputPlaceholder: 'כתוב לסוכן מה תרצה לבצע...',
        templatesDialogTitle: 'תבניות שאלות לסוכן',
        newTemplate: 'תבנית חדשה',
        templatesDialogHint: 'בחר תבנית כדי להעתיק את הטקסט לשדה הפרומפט. אפשר גם ליצור תבניות אישיות חוזרות לשימוש.',
        editTemplate: 'עריכת תבנית',
        category: 'קטגוריה',
        templateName: 'שם התבנית',
        templateText: 'טקסט התבנית',
        updateTemplate: 'עדכן תבנית',
        saveTemplate: 'שמור תבנית',
        myTemplates: 'התבניות שלי',
        noCustomTemplates: 'עדיין לא יצרת תבניות אישיות. לחץ על "תבנית חדשה" כדי להוסיף את הראשונה.',
        editTemplateAria: 'ערוך תבנית',
        deleteTemplateAria: 'מחק תבנית',
        builtinTemplates: 'תבניות מובנות',
        customCategory: 'אישי',
        settingsTitle: 'הגדרות סוכן AI',
        tabMemories: 'זיכרונות',
        tabApprovals: 'פעולות לאישור',
        tabUsage: 'שימוש וחיוב',
        tabInvoices: 'חשבוניות',
        invoicesTitle: 'חשבוניות',
        invoicesHint: 'הזן פרטי API כדי שהסוכן יוכל לחפש מסמכים ודוחות בחשבונית ירוקה. המפתח והסוד נשמרים מוצפנים.',
        saveScope: 'Scope שמירה',
        scopeMyUserOnly: 'המשתמש שלי בלבד',
        scopeOrg: 'כל הארגון',
        existingConnection: 'חיבור קיים: מפתח {key} · סוד {secret}',
        savedLabel: 'שמור',
        enterApiKey: 'הזן API Key',
        enterApiSecret: 'הזן API Secret',
        keepEmptyKey: 'השאר ריק כדי לא לשנות מפתח קיים.',
        keepEmptySecret: 'השאר ריק כדי לא לשנות סוד קיים.',
        testConnection: 'בדוק חיבור',
        memoriesTitle: 'ניהול זיכרונות אישיים',
        memoryType: 'סוג',
        memoryKey: 'מפתח',
        memoryValue: 'ערך הזיכרון',
        updateMemory: 'עדכן זיכרון',
        addMemory: 'הוסף זיכרון',
        cancelEdit: 'בטל עריכה',
        noMemories: 'אין עדיין זיכרונות שמורים.',
        updatedAtLabel: 'עודכן',
        noPendingActions: 'אין פעולות שממתינות לאישור כרגע.',
        conversationLabel: 'שיחה:',
        usageTitle: 'קרדיטים, שימוש ועלויות AI',
        creditBalance: 'יתרת קרדיטים',
        availableOf: 'זמינים {available} מתוך {total}',
        lowBalance: 'יתרה נמוכה',
        refreshCredits: 'רענן קרדיטים',
        syncPayment: 'סנכרן תשלום',
        reportScope: 'Scope דוח',
        scopeMyUser: 'המשתמש שלי',
        refreshReport: 'רענן דוח',
        requestsLabel: 'בקשות',
        tokensLabel: 'טוקנים',
        costLabel: 'עלות',
        recommendedCharge: 'חיוב מומלץ',
        expectedProfit: 'רווח צפוי',
        billingSettingsTitle: 'הגדרות חיוב ורווח',
        billingScope: 'Scope חיוב',
        markupPercent: 'מרווח רווח באחוזים',
        saveMarkup: 'שמור מרווח',
        markupHint: 'החיוב המומלץ מחושב לפי עלות ה־AI בפועל בתוספת מרווח הרווח שהוגדר.',
        buyCreditsTitle: 'רכישת קרדיטים לסוכן AI',
        syncPaymentAndUpdate: 'סנכרן תשלום ועדכן יתרה',
        promptRoles: ['הנהלה', 'כספים', 'שירות לקוחות', 'מכירות'],
        promptTemplates: [
            { role: 'הנהלה', label: 'סיכום יומי', prompt: 'סכם לי מה קרה היום במיילים, ביומן ובאוטומציות שלי, והצע את 5 הפעולות הבאות לפי דחיפות.' },
            { role: 'הנהלה', label: 'דוח סטטוס', prompt: 'הפק דוח קצר על מצב העבודה השבוע: לקוחות שממתינים לתשובה, פגישות קרובות, ואוטומציות שדורשות בדיקה.' },
            { role: 'הנהלה', label: 'בדיקת יכולות', prompt: 'בדוק אילו יכולות זמינות לי כרגע: מיילים, יומן, אוטומציות, תיוק וחיבורי ענן.' },
            { role: 'הנהלה', label: 'הכנת משימה', prompt: 'הכן לי רשימת משימות להמשך טיפול מתוך המיילים האחרונים, בלי לבצע שום פעולה לפני אישור שלי.' },
            { role: 'הנהלה', label: 'שיפור תהליכים', prompt: 'בדוק את רשימת האוטומציות שלי והצע 3 שיפורים פרקטיים להפחתת עבודה ידנית.' },
            { role: 'כספים', label: 'חשבוניות במייל', prompt: 'חפש במיילים שלי הודעות בנושא "חשבונית" וסכם לי את 10 התוצאות החשובות ביותר.' },
            { role: 'כספים', label: 'חשבונית ירוקה', prompt: 'חפש בחשבונית ירוקה מסמכים שקשורים ללקוח "דני" וסכם לי מספר מסמך, תאריך, סטטוס וסכום.' },
            { role: 'כספים', label: 'מסמכים פתוחים', prompt: 'חפש בחשבונית ירוקה מסמכים פתוחים או שלא שולמו וסדר אותם לפי דחיפות.' },
            { role: 'כספים', label: 'דוח פיננסי', prompt: 'הפק לי דוח קצר מחשבונית ירוקה על מסמכים מהחודש האחרון: כמה נמצאו, אילו לקוחות בולטים ומה דורש טיפול.' },
            { role: 'כספים', label: 'אוטומציה לחשבוניות', prompt: 'הכן אוטומציה חדשה שמזהה מיילים בנושא חשבונית, מחלץ סכום, ספק ותאריך, ושולח את התוצאה למייל שלי. בקש אישור לפני יצירה.' },
            { role: 'שירות לקוחות', label: 'חיפוש לקוח', prompt: 'חפש מיילים שקשורים ללקוח בשם "דני" והצג לי נושא, שולח ותאריך לכל תוצאה.' },
            { role: 'שירות לקוחות', label: 'סיכום טיפול', prompt: 'חפש מיילים בנושא "הצעת מחיר" וסכם לי מה צריך טיפול ומה כבר נסגר.' },
            { role: 'שירות לקוחות', label: 'ניסוח תשובה', prompt: 'נסח מייל מקצועי ללקוח שמעדכן שקיבלנו את המסמכים ונחזור אליו עם תשובה עד מחר. אל תשלח בלי אישור שלי.' },
            { role: 'שירות לקוחות', label: 'יומן שבועי', prompt: 'נתח וסכם לי את האירועים ביומן לשבעת הימים הקרובים לפי ימים ושעות, כולל התראות/תזכורות והתנגשויות אם יש.' },
            { role: 'שירות לקוחות', label: 'סנכרון יומן', prompt: 'סנכרן במלואו את חיבורי Google/Outlook שלי ואז סכם בקצרה מה התעדכן ביומן.' },
            { role: 'שירות לקוחות', label: 'יצירת אירוע', prompt: 'צור לי אירוע ביומן למחר בשעה 10:00 בשם "שיחת מעקב עם לקוח" למשך שעה, עם תזכורת 15 דקות לפני. הצג אישור לפני ביצוע.' },
            { role: 'מכירות', label: 'לידים חמים', prompt: 'מצא מיילים מהשבוע האחרון שמרמזים על ליד או בקשת הצעת מחיר, וסדר אותם לפי סיכוי לסגירה.' },
            { role: 'מכירות', label: 'מייל המשך', prompt: 'הכן לשליחה מייל קצר ללקוח שמבקש את הפרטים החסרים להצעת מחיר. הצג לי את הנמען, הנושא והתוכן לפני אישור שליחה.' },
            { role: 'מכירות', label: 'חשבונות מייל', prompt: 'הצג לי את כל חשבונות המייל שמחוברים למשתמש שלי, כולל שם תצוגה ופרוטוקול.' },
            { role: 'מכירות', label: 'חיבורי ענן', prompt: 'הצג לי את חיבורי Google Drive ו-Dropbox הפעילים שלי ואת כללי התיוק שמוגדרים עבורם.' },
            { role: 'מכירות', label: 'זיכרון אישי', prompt: 'זכור שאני מעדיף לקבל סיכומים בעברית, עם פעולות לביצוע בראש הרשימה וללא פירוט מיותר.' },
        ],
    },

    // ==================== PWA INSTALL BANNER ====================
    pwa: {
        installSubtitle: 'התקן את האפליקציה לחוויה מהירה יותר',
        iosHowTo: 'כדי להתקין באייפון:',
        iosStep1: '1. לחץ על כפתור השיתוף',
        iosStep2: '2. גלול למטה ובחר "הוסף למסך הבית"',
        iosStep3: '3. לחץ "הוסף" בפינה הימנית העליונה',
        gotIt: 'הבנתי',
        installInstructions: 'הוראות התקנה',
        installApp: 'התקן אפליקציה',
        notNow: 'לא עכשיו',
        noStoreNeeded: 'ללא צורך בהורדה מחנות • גישה מהירה מהמסך הראשי',
    },

    // ==================== PAYMENT RESULT ====================
    payment: {
        successTitle: 'תשלום הושלם | Email Lion',
        failureTitle: 'תשלום נכשל | Email Lion',
        successHeading: 'התשלום הושלם בהצלחה!',
        successBody: 'תודה על רכישתך. החבילה תופעל בקרוב ותקבל אימייל עם פרטי ההפעלה.',
        loginBtn: 'כניסה למערכת',
        homeBtn: 'דף הבית',
        failureHeading: 'התשלום לא הושלם',
        failureBody: 'אירעה שגיאה בעיבוד התשלום. ניתן לנסות שוב או ליצור קשר עם התמיכה.',
        tryAgain: 'נסה שוב',
    },
};

export default he;
